<template>
    <div>
        <h2 class="mb-1">Call Data Report</h2>
        
        <div style="display: flex; flex-wrap: wrap; align-items: center;" class="mb-2">
            <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                variant="outline-primary"
                class="btn-icon mr-50"
                style="height: 37px; margin-top: 12px;"
                @click.stop.prevent="prevRange()"
            >
                <feather-icon icon="ChevronLeftIcon" />
            </b-button>

            <b-form-group
                label="Start Date"
                class="mr-50 w-10"
            >
                <date-picker v-model="startDate" type="month" format="MM-DD-YYYY" value-type="DD/MM/YYYY" v-if="selectedRangeDate === 'month' || selectedRangeDate === 'quarter'"></date-picker>
                <date-picker v-model="startDate" type="year" format="MM-DD-YYYY" value-type="DD/MM/YYYY" v-else-if="selectedRangeDate === 'year'"></date-picker>
                <date-picker v-model="startDate" type="date" format="MM-DD-YYYY" value-type="DD/MM/YYYY" v-else-if="!selectedRangeDate || selectedRangeDate === 'custom'"></date-picker>
            </b-form-group>
        
            <b-form-group
                label="End Date"
                class="mr-50"
            >
                <date-picker v-model="endDate" type="date" format="MM-DD-YYYY" value-type="DD/MM/YYYY" :disabled="selectedRangeDate === 'month' || selectedRangeDate === 'quarter' || selectedRangeDate === 'year' ? true : false"></date-picker>
            </b-form-group>

            <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                variant="outline-primary"
                class="btn-icon ml-0"
                style="height: 37px; margin-top: 12px;"
                @click.stop.prevent="nextRange()"
            >
                <feather-icon icon="ChevronRightIcon" />
            </b-button>
            
            <div :class="!selectedRangeDate ? 'pl-1' : 'pl-1'">
                <b-form-group>
                    <b-form-radio-group
                        v-model="selectedRangeDate"
                        button-variant="outline-primary range-date"
                        buttons
                        class="p-0 mr-2"
                    >
                        <b-form-radio style="height: 37px; padding: 11px;" v-for="(option,index) in optionsRangeDate" :key="index" :value="option.value">{{option.text}}</b-form-radio>
                        <b-form-radio style="height: 37px; padding: 10px;" v-if="selectedRangeDate" value="x">x</b-form-radio>
                    </b-form-radio-group>
                </b-form-group>
            </div>
            
            <b-form-group
                label="Region"
            >
                <v-select
                    v-model="region"
                    placeholder="Region"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="optionsRegion"
                    style="background: #fff; min-width: 200px;"
                    class="mr-2"
                />
            </b-form-group>
        
            <b-form-group
                label="Borough"
                v-if="region === 'NYC'"
            >
                <v-select
                    v-model="borough"
                    placeholder="Any Borough"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="optionsBorough"
                    style="background: #fff; min-width: 200px;"
                    class="mr-2"
                />
            </b-form-group>
        
            <b-form-group
                label="Language"
            >
                <v-select
                    v-model="language"
                    placeholder="Language"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="optionsLanguage"
                    style="background: #fff; min-width: 200px;"
                    class="mr-2"
                />
            </b-form-group>
        
            <b-form-group
                label="Warm Transfer"
            >
                <v-select
                    v-model="warmTransfer"
                    placeholder="Warm Transfer"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="optionsWarmTransfer"
                    style="background: #fff; min-width: 200px;"
                    class="mr-2"
                />
            </b-form-group>

            <b-form-group
                label="Program"
            >
                <b-form-select
                    v-model="clinicianProgram"
                    inline
                    :options="optionsProgram"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    style="min-width: 200px;"
                    class="d-inline-block mr-2"
                />
            </b-form-group>

            <b-form-group
                label="Method of Contact"
                class="ml-2"
            >
                <v-select
                    v-model="methodOfContact"
                    placeholder="Method of Contact"
                    :options="optionsMethodOfContact"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    style="background: #fff; min-width: 250px;"
                    class=" mr-2"
                />
            </b-form-group>

            <b-form-group
                label="Caller Type"
            >
                <v-select
                    v-model="contactStatus"
                    placeholder="Caller Type"
                    :options="optionsContactStatus"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    style="background: #fff; min-width: 250px;"
                    class=" mr-2"
                />
            </b-form-group>

            <b-form-group
                label="Information Kit Accepted"
            >
                <v-select
                    v-model="informationKitAccepted"
                    placeholder="Information Kit Accepted"
                    :options="optionsInformationKitAccepted"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    style="background: #fff; min-width: 250px;"
                    class=" mr-2"
                />
            </b-form-group>

            <b-form-group
                label="Readmission"
            >
                <v-select
                    v-model="readmission"
                    placeholder="Readmission"
                    :options="optionsReadmission"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    style="background: #fff; min-width: 250px;"
                    class=" mr-2"
                />
            </b-form-group>

            <b-form-group
                label="Connected to Peer Advocate"
            >
                <v-select
                    v-model="connectedToPeerAdvocate"
                    placeholder="Connected to Peer Advocate"
                    :options="optionsConnectedToPeerAdvocate"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    style="background: #fff; min-width: 250px;"
                    class=" mr-2"
                />
            </b-form-group>

            <b-form-group
                label="Connected to VSE"
            >
                <v-select
                    v-model="connectedToVSE"
                    placeholder="Connected to VSE"
                    :options="optionsConnected"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    style="background: #fff; min-width: 250px;"
                    class=" mr-2"
                />
            </b-form-group>

            <b-form-group
                label="Connected to peer education group"
            >
                <v-select
                    v-model="connectedToPeerEducationGroup"
                    placeholder="Connected to peer education group"
                    :options="optionsConnectedToPeer"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    style="background: #fff; min-width: 250px;"
                    class=" mr-2"
                />
            </b-form-group>

            <b-form-group
                label="Connected to family education group"
            >
                <v-select
                    v-model="connectedToFamilyEducationGroup"
                    placeholder="Connected to family education group"
                    :options="optionsConnectedToFamily"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    style="background: #fff; min-width: 250px;"
                    class=" mr-2"
                />
            </b-form-group>

            <b-form-group
                label="Connected to Asian Services Program"
            >
                <v-select
                    v-model="connectedToAsianServicesProgram"
                    placeholder="Connected to Asian Services Program"
                    :options="optionsConnectedToAsian"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    style="background: #fff; min-width: 250px;"
                    class=" mr-2"
                />
            </b-form-group>

            <b-form-group
                label="Referral Options"
            >
                <v-select
                    v-model="referralOptions"
                    placeholder="Referral Options"
                    :options="optionsReferralOptions"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    style="background: #fff; min-width: 250px;"
                    class=" mr-2"
                />
            </b-form-group>

            <div>
                <b-button
                    v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                    variant="flat-primary"
                    class="mb-1 mt-2 p-75"
                    @click="activeFilterFunction"
                >
                    <feather-icon
                        icon="Xicon"
                        class="mr-50"
                    />
                    <span class="align-middle">Reset filters</span>
                </b-button>
            </div>
        </div>

        <b-card>
            <h5>Engagement Sessions</h5>
            <hr>
            <b-row>
                <!-- Total Individuals -->
                <b-col
                    lg="6"
                    md="6"
                    sm="12"
                >
                    <b-card no-body style="border: 1px solid #ecebed;">
                        <b-card-body class="d-flex justify-content-between align-items-center">
                        <div class="truncate">
                            <div class="text-primary" v-if="isBusy">
                                <b-spinner class="align-middle"></b-spinner>
                            </div>
                            <h2 class="mb-25 font-weight-bolder" v-else>
                            {{ engagementFormCompleted && engagementFormCompleted !== 'NaN' ? engagementFormCompleted.toLocaleString('en-US') : 0 }}
                            </h2>
                            <span>Total Individuals</span>
                        </div>
                        </b-card-body>
                    </b-card>
                </b-col>

                <!-- Scheduled For Initial Appointment -->
                <b-col
                    lg="6"
                    md="6"
                    sm="12"
                >
                    <b-card no-body style="border: 1px solid #ecebed;">
                        <b-card-body class="d-flex justify-content-between align-items-center">
                        <div class="truncate">
                            <div class="text-primary" v-if="isBusy">
                                <b-spinner class="align-middle"></b-spinner>
                            </div>
                            <h2 class="mb-25 font-weight-bolder" v-else>
                            {{ counterInitialAppointmentDate && counterInitialAppointmentDate !== 'NaN' ? counterInitialAppointmentDate.toLocaleString('en-US') : 0 }}
                            </h2>
                            <span>Scheduled For Initial Appointment</span>
                        </div>
                        </b-card-body>
                    </b-card>
                </b-col>
            </b-row>

            <b-row>
                <!-- Total Eligible Callers -->
                <b-col
                    lg="4"
                    md="4"
                    sm="12"
                >
                    <b-card no-body style="border: 1px solid #ecebed;">
                        <b-card-body class="d-flex justify-content-between align-items-center">
                        <div class="truncate">
                            <div class="text-primary" v-if="isBusy">
                                <b-spinner class="align-middle"></b-spinner>
                            </div>
                            <h2 class="mb-25 font-weight-bolder" v-else>
                            {{ counterTotalEligibleCallers && counterTotalEligibleCallers !== 'NaN' ? counterTotalEligibleCallers.toLocaleString('en-US') : 0 }}
                            </h2>
                            <span>Total Eligible Callers</span>
                        </div>
                        </b-card-body>
                    </b-card>
                </b-col>

                <!-- Attended Face To Face Session -->
                <b-col
                    lg="4"
                    md="4"
                    sm="12"
                >
                    <b-card no-body style="border: 1px solid #ecebed;">
                        <b-card-body class="d-flex justify-content-between align-items-center">
                        <div class="truncate">
                            <div class="text-primary" v-if="isBusy">
                                <b-spinner class="align-middle"></b-spinner>
                            </div>
                            <h2 class="mb-25 font-weight-bolder" v-else>
                            {{ counterAttendedFaceToFaceSession && counterAttendedFaceToFaceSession !== 'NaN' ? counterAttendedFaceToFaceSession.toLocaleString('en-US') : 0 }}
                            </h2>
                            <span>Attended Face To Face Session</span>
                        </div>
                        </b-card-body>
                    </b-card>
                </b-col>

                <!-- Admitted To Treatment -->
                <b-col
                    lg="4"
                    md="4"
                    sm="12"
                >
                    <b-card no-body style="border: 1px solid #ecebed;">
                        <b-card-body class="d-flex justify-content-between align-items-center">
                        <div class="truncate">
                            <div class="text-primary" v-if="isBusy">
                                <b-spinner class="align-middle"></b-spinner>
                            </div>
                            <h2 class="mb-25 font-weight-bolder" v-else>
                            {{ counterAdmittedToTreatment && counterAdmittedToTreatment !== 'NaN' ? counterAdmittedToTreatment.toLocaleString('en-US') : 0 }}
                            </h2>
                            <span>Admitted To Treatment</span>
                        </div>
                        </b-card-body>
                    </b-card>
                </b-col>
            </b-row>

            <b-row>
                <b-col
                    lg="3"
                    md="3"
                    sm="12"
                    v-for="(item, index) in optMethodOfContact"
                    :key="item.name+index"
                >
                    <b-card no-body style="border: 1px solid #ecebed;">
                        <b-card-body class="d-flex justify-content-between align-items-center">
                        <div class="truncate">
                            <div class="text-primary" v-if="isBusy">
                                <b-spinner class="align-middle"></b-spinner>
                            </div>
                            <h2 class="mb-25 font-weight-bolder" v-else>
                            {{ item.count && item.count !== 'NaN' ? item.count.toFixed(0) : 0 }}
                            </h2>
                            <span>{{item.name}}</span>
                        </div>
                        </b-card-body>
                    </b-card>
                </b-col>

                <b-col
                    lg="3"
                    md="3"
                    sm="12"
                    v-for="(item, index) in optContactStatus"
                    :key="item.name+index"
                >
                    <b-card no-body style="border: 1px solid #ecebed;">
                        <b-card-body class="d-flex justify-content-between align-items-center">
                        <div class="truncate">
                            <div class="text-primary" v-if="isBusy">
                                <b-spinner class="align-middle"></b-spinner>
                            </div>
                            <h2 class="mb-25 font-weight-bolder" v-else>
                            {{ item.count && item.count !== 'NaN' ? item.count.toFixed(0) : 0 }}
                            </h2>
                            <span>{{item.name}}</span>
                        </div>
                        </b-card-body>
                    </b-card>
                </b-col>

                <b-col
                    lg="3"
                    md="3"
                    sm="12"
                    v-for="(item, index) in optInformationKitAccepted"
                    :key="item.name+index"
                >
                    <b-card no-body style="border: 1px solid #ecebed;">
                        <b-card-body class="d-flex justify-content-between align-items-center">
                        <div class="truncate">
                            <div class="text-primary" v-if="isBusy">
                                <b-spinner class="align-middle"></b-spinner>
                            </div>
                            <h2 class="mb-25 font-weight-bolder" v-else>
                            {{ item.count && item.count !== 'NaN' ? item.count.toFixed(0) : 0 }}
                            </h2>
                            <span>{{item.name}}</span>
                        </div>
                        </b-card-body>
                    </b-card>
                </b-col>

                <b-col
                    lg="3"
                    md="3"
                    sm="12"
                    v-for="(item, index) in optReadmission"
                    :key="item.name+index"
                >
                    <b-card no-body style="border: 1px solid #ecebed;">
                        <b-card-body class="d-flex justify-content-between align-items-center">
                        <div class="truncate">
                            <div class="text-primary" v-if="isBusy">
                                <b-spinner class="align-middle"></b-spinner>
                            </div>
                            <h2 class="mb-25 font-weight-bolder" v-else>
                            {{ item.count && item.count !== 'NaN' ? item.count.toFixed(0) : 0 }}
                            </h2>
                            <span>{{item.name}}</span>
                        </div>
                        </b-card-body>
                    </b-card>
                </b-col>

                <b-col
                    lg="3"
                    md="3"
                    sm="12"
                    v-for="(item, index) in optConnectedToPeerAdvocate"
                    :key="item.name+index"
                >
                    <b-card no-body style="border: 1px solid #ecebed;">
                        <b-card-body class="d-flex justify-content-between align-items-center">
                        <div class="truncate">
                            <div class="text-primary" v-if="isBusy">
                                <b-spinner class="align-middle"></b-spinner>
                            </div>
                            <h2 class="mb-25 font-weight-bolder" v-else>
                            {{ item.count && item.count !== 'NaN' ? item.count.toFixed(0) : 0 }}
                            </h2>
                            <span>{{item.name}}</span>
                        </div>
                        </b-card-body>
                    </b-card>
                </b-col>

                <b-col
                    lg="3"
                    md="3"
                    sm="12"
                    v-for="(item, index) in optConnected"
                    :key="item.name+index"
                >
                    <b-card no-body style="border: 1px solid #ecebed;">
                        <b-card-body class="d-flex justify-content-between align-items-center">
                        <div class="truncate">
                            <div class="text-primary" v-if="isBusy">
                                <b-spinner class="align-middle"></b-spinner>
                            </div>
                            <h2 class="mb-25 font-weight-bolder" v-else>
                            {{ item.count && item.count !== 'NaN' ? item.count.toFixed(0) : 0 }}
                            </h2>
                            <span>{{item.name}}</span>
                        </div>
                        </b-card-body>
                    </b-card>
                </b-col>

                <b-col
                    lg="3"
                    md="3"
                    sm="12"
                    v-for="(item, index) in optConnectedToPeer"
                    :key="item.name+index"
                >
                    <b-card no-body style="border: 1px solid #ecebed;">
                        <b-card-body class="d-flex justify-content-between align-items-center">
                        <div class="truncate">
                            <div class="text-primary" v-if="isBusy">
                                <b-spinner class="align-middle"></b-spinner>
                            </div>
                            <h2 class="mb-25 font-weight-bolder" v-else>
                            {{ item.count && item.count !== 'NaN' ? item.count.toFixed(0) : 0 }}
                            </h2>
                            <span>{{item.name}}</span>
                        </div>
                        </b-card-body>
                    </b-card>
                </b-col>

                <b-col
                    lg="3"
                    md="3"
                    sm="12"
                    v-for="(item, index) in optConnectedToFamily"
                    :key="item.name+index"
                >
                    <b-card no-body style="border: 1px solid #ecebed;">
                        <b-card-body class="d-flex justify-content-between align-items-center">
                        <div class="truncate">
                            <div class="text-primary" v-if="isBusy">
                                <b-spinner class="align-middle"></b-spinner>
                            </div>
                            <h2 class="mb-25 font-weight-bolder" v-else>
                            {{ item.count && item.count !== 'NaN' ? item.count.toFixed(0) : 0 }}
                            </h2>
                            <span>{{item.name}}</span>
                        </div>
                        </b-card-body>
                    </b-card>
                </b-col>

                <b-col
                    lg="3"
                    md="3"
                    sm="12"
                    v-for="(item, index) in optConnectedToAsian"
                    :key="item.name+index"
                >
                    <b-card no-body style="border: 1px solid #ecebed;">
                        <b-card-body class="d-flex justify-content-between align-items-center">
                        <div class="truncate">
                            <div class="text-primary" v-if="isBusy">
                                <b-spinner class="align-middle"></b-spinner>
                            </div>
                            <h2 class="mb-25 font-weight-bolder" v-else>
                            {{ item.count && item.count !== 'NaN' ? item.count.toFixed(0) : 0 }}
                            </h2>
                            <span>{{item.name}}</span>
                        </div>
                        </b-card-body>
                    </b-card>
                </b-col>

                <b-col
                    lg="3"
                    md="3"
                    sm="12"
                    v-for="(item, index) in optReferralOptions"
                    :key="item.name+index"
                >
                    <b-card no-body style="border: 1px solid #ecebed;">
                        <b-card-body class="d-flex justify-content-between align-items-center">
                        <div class="truncate">
                            <div class="text-primary" v-if="isBusy">
                                <b-spinner class="align-middle"></b-spinner>
                            </div>
                            <h2 class="mb-25 font-weight-bolder" v-else>
                            {{ item.count && item.count !== 'NaN' ? item.count.toFixed(0) : 0 }}
                            </h2>
                            <span>{{item.name}}</span>
                        </div>
                        </b-card-body>
                    </b-card>
                </b-col>
                
                <b-col
                    lg="3"
                    md="3"
                    sm="12"
                    v-for="(item, index) in optConnectedtoGamFin"
                    :key="item.name+index"
                >
                    <b-card no-body style="border: 1px solid #ecebed;">
                        <b-card-body class="d-flex justify-content-between align-items-center">
                        <div class="truncate">
                            <div class="text-primary" v-if="isBusy">
                                <b-spinner class="align-middle"></b-spinner>
                            </div>
                            <h2 class="mb-25 font-weight-bolder" v-else>
                            {{ item.count && item.count !== 'NaN' ? item.count.toFixed(0) : 0 }}
                            </h2>
                            <span>{{item.name}}</span>
                        </div>
                        </b-card-body>
                    </b-card>
                </b-col>

                <b-col
                    lg="3"
                    md="3"
                    sm="12"
                    v-for="(item, index) in optReferredtoPeerAdvocate"
                    :key="item.name+index"
                >
                    <b-card no-body style="border: 1px solid #ecebed;">
                        <b-card-body class="d-flex justify-content-between align-items-center">
                        <div class="truncate">
                            <div class="text-primary" v-if="isBusy">
                                <b-spinner class="align-middle"></b-spinner>
                            </div>
                            <h2 class="mb-25 font-weight-bolder" v-else>
                            {{ item.count && item.count !== 'NaN' ? item.count.toFixed(0) : 0 }}
                            </h2>
                            <span>{{item.name}}</span>
                        </div>
                        </b-card-body>
                    </b-card>
                </b-col>

                <b-col
                    lg="3"
                    md="3"
                    sm="12"
                    v-for="(item, index) in optReferralOASASProgram"
                    :key="item.name+index"
                >
                    <b-card no-body style="border: 1px solid #ecebed;">
                        <b-card-body class="d-flex justify-content-between align-items-center">
                        <div class="truncate">
                            <div class="text-primary" v-if="isBusy">
                                <b-spinner class="align-middle"></b-spinner>
                            </div>
                            <h2 class="mb-25 font-weight-bolder" v-else>
                            {{ item.count && item.count !== 'NaN' ? item.count.toFixed(0) : 0 }}
                            </h2>
                            <span>{{item.name}}</span>
                        </div>
                        </b-card-body>
                    </b-card>
                </b-col>

                <b-col
                    lg="3"
                    md="3"
                    sm="12"
                    v-for="(item, index) in optReferralRecoverySupportServices"
                    :key="item.name+index"
                >
                    <b-card no-body style="border: 1px solid #ecebed;">
                        <b-card-body class="d-flex justify-content-between align-items-center">
                        <div class="truncate">
                            <div class="text-primary" v-if="isBusy">
                                <b-spinner class="align-middle"></b-spinner>
                            </div>
                            <h2 class="mb-25 font-weight-bolder" v-else>
                            {{ item.count && item.count !== 'NaN' ? item.count.toFixed(0) : 0 }}
                            </h2>
                            <span>{{item.name}}</span>
                        </div>
                        </b-card-body>
                    </b-card>
                </b-col>
            </b-row>
        </b-card>

        <download-csv 
            :data="json_data"
            class="mb-1 btn btn-default"
            name="reports-call-data.csv"
            :style="readyToExport ? 'background: #94221e; color: #fff; cursor: pointer; opacity: 1;' : 'background: #94221e; color: #fff; cursor: no-drop; opacity: 0.5;'"
            delimiter=","
            v-if="isDataSpecialist"
        >
            CSV Export
            <b-spinner small v-if="!readyToExport" />
        </download-csv>

        <b-card>
            <h4>Calls Received By Referral Source</h4>
            <b-table
                :items="arrayTableContent"
                :fields="fieldsTable"
                responsive="sm"
                thead-class="hidden_header"
                :busy="isBusyCalls"
                v-if="isBusyCalls"
            >
                <template #table-busy>
                    <div class="text-center text-primary my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong class="ml-1">Loading...</strong>
                    </div>
                </template>
                <!-- Column: Quantity -->
                <template #cell(quantity)="data">
                    <h4>{{ data.item.name === 'Existing or past CFE client' ? countExistingorpastCFEclient : data.item.name === 'Family Member / Self' ? countFamilymemberSelf : data.item.name === 'GA/ GamAnon' ? countGAGamAnon : data.item.name === 'HOPEline' ? countHOPEline : data.item.name === 'Warm Transfer' ? counterWarmTransfer : data.item.name === 'Internet Search' ? countInternetSearch : data.item.name === 'Legal System' ? countLegalSystem : data.item.name === 'Other (please describe)' ? countOtherpleasedescribe : data.item.name === 'Other service provider' ? countOtherserviceprovider : data.item.name === 'Friends or Other Individual' ? countFriendsorOtherIndividual : data.item.name === 'Problem Gambling Self-Help Group Meetings' ? countProblemGamblingSelfHelpGroupMeetings : data.item.name === 'Substance Use Self-Help Group Meetings' ? countSubstanceUseSelfHelpGroupMeetings : data.item.name === 'Financial Counseling' ? countFinancialCounseling : data.item.name === 'Crisis Services' ? countCrisisServices : data.item.name === 'Problem Gambling Treatment Services' ? countProblemGamblingTreatmentServices : data.item.name === 'Substance Use Treatment Services' ? countSubstanceUseTreatmentServices : data.item.name === 'Recovery Support Services' ? countRecoverySupportServices : data.item.quantity }}</h4>
                </template>
            </b-table>
            <table class="w-100" v-else>
                <tr style="border-bottom: 1px solid #f0f0f0;">
                    <td class="w-80" style="padding: 10px;">HOPEline</td>
                    <td class="w-20" style="padding: 10px;">{{ countHOPEline }}</td>
                </tr>
                    <tr style="border-bottom: 1px solid #f0f0f0;">
                        <td class="w-80 ml-4 d-block" style="padding: 10px;">Yes</td>
                        <td class="w-20" style="padding: 10px;">{{ countHOPElineYes }}</td>
                    </tr>
                    <tr style="border-bottom: 1px solid #f0f0f0;">
                        <td class="w-80 ml-4 d-block" style="padding: 10px;">No</td>
                        <td class="w-20" style="padding: 10px;">{{ countHOPElineNo }}</td>
                    </tr>
                <tr style="border-bottom: 1px solid #f0f0f0;">
                    <td class="w-80" style="padding: 10px;">Family Member / Self</td>
                    <td class="w-20" style="padding: 10px;">{{ countFamilymemberSelf }}</td>
                </tr>
                    <tr style="border-bottom: 1px solid #f0f0f0;">
                        <td class="w-80 ml-4 d-block" style="padding: 10px;">Self-Referral</td>
                        <td class="w-20" style="padding: 10px;">{{ countFamilymemberSelfSelfReferral }}</td>
                    </tr>
                    <tr style="border-bottom: 1px solid #f0f0f0;">
                        <td class="w-80 ml-4 d-block" style="padding: 10px;">Spouse</td>
                        <td class="w-20" style="padding: 10px;">{{ countFamilymemberSelfSpouce }}</td>
                    </tr>
                    <tr style="border-bottom: 1px solid #f0f0f0;">
                        <td class="w-80 ml-4 d-block" style="padding: 10px;">Family member</td>
                        <td class="w-20" style="padding: 10px;">{{ countFamilymemberSelfFamilyMember }}</td>
                    </tr>
                <tr style="border-bottom: 1px solid #f0f0f0;">
                    <td class="w-80" style="padding: 10px;">Problem Gambling Self-Help Group Meetings</td>
                    <td class="w-20" style="padding: 10px;">{{ countProblemGamblingSelfHelpGroupMeetings }}</td>
                </tr>
                    <tr style="border-bottom: 1px solid #f0f0f0;">
                        <td class="w-80 ml-4 d-block" style="padding: 10px;">GA</td>
                        <td class="w-20" style="padding: 10px;">{{ countProblemGamblingSelfHelpGroupMeetingsGA }}</td>
                    </tr>
                    <tr style="border-bottom: 1px solid #f0f0f0;">
                        <td class="w-80 ml-4 d-block" style="padding: 10px;">GamAnon</td>
                        <td class="w-20" style="padding: 10px;">{{ countProblemGamblingSelfHelpGroupMeetingsGamAnon }}</td>
                    </tr>
                    <tr style="border-bottom: 1px solid #f0f0f0;">
                        <td class="w-80 ml-4 d-block" style="padding: 10px;">Smart Recovery</td>
                        <td class="w-20" style="padding: 10px;">{{ countProblemGamblingSelfHelpGroupMeetingsSmartRecovery }}</td>
                    </tr>
                    <tr style="border-bottom: 1px solid #f0f0f0;">
                        <td class="w-80 ml-4 d-block" style="padding: 10px;">Other</td>
                        <td class="w-20" style="padding: 10px;">{{ countProblemGamblingSelfHelpGroupMeetingsOther }}</td>
                    </tr>
                <tr style="border-bottom: 1px solid #f0f0f0;">
                    <td class="w-80" style="padding: 10px;">Problem Gambling Treatment Services</td>
                    <td class="w-20" style="padding: 10px;">{{ countProblemGamblingTreatmentServices }}</td>
                </tr>
                    <tr style="border-bottom: 1px solid #f0f0f0;">
                        <td class="w-80 ml-4 d-block" style="padding: 10px;">Inpatient Rehabilitation</td>
                        <td class="w-20" style="padding: 10px;">{{ countProblemGamblingTreatmentServicesInpatientRehabilitation }}</td>
                    </tr>
                    <tr style="border-bottom: 1px solid #f0f0f0;">
                        <td class="w-80 ml-4 d-block" style="padding: 10px;">Residential</td>
                        <td class="w-20" style="padding: 10px;">{{ countProblemGamblingTreatmentServicesResidential }}</td>
                    </tr>
                    <tr style="border-bottom: 1px solid #f0f0f0;">
                        <td class="w-80 ml-4 d-block" style="padding: 10px;">Outpatient</td>
                        <td class="w-20" style="padding: 10px;">{{ countProblemGamblingTreatmentServicesOutpatient }}</td>
                    </tr>
                <tr style="border-bottom: 1px solid #f0f0f0;">
                    <td class="w-80" style="padding: 10px;">Substance Use Treatment Services</td>
                    <td class="w-20" style="padding: 10px;">{{ countSubstanceUseTreatmentServices }}</td>
                </tr>
                    <tr style="border-bottom: 1px solid #f0f0f0;">
                        <td class="w-80 ml-4 d-block" style="padding: 10px;">Inpatient Rehabilitation</td>
                        <td class="w-20" style="padding: 10px;">{{ countSubstanceUseTreatmentServicesInpatientRehabilitation }}</td>
                    </tr>
                    <tr style="border-bottom: 1px solid #f0f0f0;">
                        <td class="w-80 ml-4 d-block" style="padding: 10px;">Residential</td>
                        <td class="w-20" style="padding: 10px;">{{ countSubstanceUseTreatmentServicesResidential }}</td>
                    </tr>
                    <tr style="border-bottom: 1px solid #f0f0f0;">
                        <td class="w-80 ml-4 d-block" style="padding: 10px;">Outpatient</td>
                        <td class="w-20" style="padding: 10px;">{{ countSubstanceUseTreatmentServicesOutpatient }}</td>
                    </tr>
                <tr style="border-bottom: 1px solid #f0f0f0;">
                    <td class="w-80" style="padding: 10px;">Recovery Support Services</td>
                    <td class="w-20" style="padding: 10px;">{{ countRecoverySupportServices }}</td>
                </tr>
                    <tr style="border-bottom: 1px solid #f0f0f0;">
                        <td class="w-80 ml-4 d-block" style="padding: 10px;">Recovery Community and Outreach Center</td>
                        <td class="w-20" style="padding: 10px;">{{ countRecoverySupportServicesRCOC }}</td>
                    </tr>
                    <tr style="border-bottom: 1px solid #f0f0f0;">
                        <td class="w-80 ml-4 d-block" style="padding: 10px;">Peer Advocate</td>
                        <td class="w-20" style="padding: 10px;">{{ countRecoverySupportServicesPeerAdvocate }}</td>
                    </tr>
                    <tr style="border-bottom: 1px solid #f0f0f0;">
                        <td class="w-80 ml-4 d-block" style="padding: 10px;">Open Access Center</td>
                        <td class="w-20" style="padding: 10px;">{{ countRecoverySupportServicesOpenAccessCenter }}</td>
                    </tr>
                    <tr style="border-bottom: 1px solid #f0f0f0;">
                        <td class="w-80 ml-4 d-block" style="padding: 10px;">Family Navigator</td>
                        <td class="w-20" style="padding: 10px;">{{ countRecoverySupportServicesFamilyNavigator }}</td>
                    </tr>
                    <tr style="border-bottom: 1px solid #f0f0f0;">
                        <td class="w-80 ml-4 d-block" style="padding: 10px;">Regional Addiction Resource Center</td>
                        <td class="w-20" style="padding: 10px;">{{ countRecoverySupportServicesRARC }}</td>
                    </tr>
                    <tr style="border-bottom: 1px solid #f0f0f0;">
                        <td class="w-80 ml-4 d-block" style="padding: 10px;">Youth Clubhouse</td>
                        <td class="w-20" style="padding: 10px;">{{ countRecoverySupportServicesYouthClubhouse }}</td>
                    </tr>
                    <tr style="border-bottom: 1px solid #f0f0f0;">
                        <td class="w-80 ml-4 d-block" style="padding: 10px;">GA</td>
                        <td class="w-20" style="padding: 10px;">{{ countRecoverySupportServicesGA }}</td>
                    </tr>
                    <tr style="border-bottom: 1px solid #f0f0f0;">
                        <td class="w-80 ml-4 d-block" style="padding: 10px;">GamAnon</td>
                        <td class="w-20" style="padding: 10px;">{{ countRecoverySupportServicesGamAnon }}</td>
                    </tr>
                    <tr style="border-bottom: 1px solid #f0f0f0;">
                        <td class="w-80 ml-4 d-block" style="padding: 10px;">Smart Recovery</td>
                        <td class="w-20" style="padding: 10px;">{{ countRecoverySupportServicesSmartRecovery }}</td>
                    </tr>
                <tr style="border-bottom: 1px solid #f0f0f0;">
                    <td class="w-80" style="padding: 10px;">Existing or past CFE client</td>
                    <td class="w-20" style="padding: 10px;">{{ countExistingorpastCFEclient }}</td>
                </tr>
                <!-- <tr style="border-bottom: 1px solid #f0f0f0;">
                    <td class="w-80" style="padding: 10px;">Family Member / Self</td>
                    <td class="w-20" style="padding: 10px;">{{ countFamilymemberSelf }}</td>
                </tr>
                    <tr style="border-bottom: 1px solid #f0f0f0;">
                        <td class="w-80 ml-4 d-block" style="padding: 10px;">Self-Referral</td>
                        <td class="w-20" style="padding: 10px;">{{ countFamilymemberSelfSelfReferral }}</td>
                    </tr>
                    <tr style="border-bottom: 1px solid #f0f0f0;">
                        <td class="w-80 ml-4 d-block" style="padding: 10px;">Spouse</td>
                        <td class="w-20" style="padding: 10px;">{{ countFamilymemberSelfSpouce }}</td>
                    </tr>
                    <tr style="border-bottom: 1px solid #f0f0f0;">
                        <td class="w-80 ml-4 d-block" style="padding: 10px;">Family member</td>
                        <td class="w-20" style="padding: 10px;">{{ countFamilymemberSelfFamilyMember }}</td>
                    </tr> -->
                <tr style="border-bottom: 1px solid #f0f0f0;">
                    <td class="w-80" style="padding: 10px;">GA/ GamAnon</td>
                    <td class="w-20" style="padding: 10px;">{{ countGAGamAnon }}</td>
                </tr>
                <!-- <tr style="border-bottom: 1px solid #f0f0f0;">
                    <td class="w-80" style="padding: 10px;">HOPEline</td>
                    <td class="w-20" style="padding: 10px;">{{ countHOPEline }}</td>
                </tr>
                    <tr style="border-bottom: 1px solid #f0f0f0;">
                        <td class="w-80 ml-4 d-block" style="padding: 10px;">Yes</td>
                        <td class="w-20" style="padding: 10px;">{{ countHOPEline }}</td>
                    </tr>
                    <tr style="border-bottom: 1px solid #f0f0f0;">
                        <td class="w-80 ml-4 d-block" style="padding: 10px;">No</td>
                        <td class="w-20" style="padding: 10px;">{{ countHOPEline }}</td>
                    </tr> -->
                <tr style="border-bottom: 1px solid #f0f0f0;">
                    <td class="w-80" style="padding: 10px;">Warm Transfer</td>
                    <td class="w-20" style="padding: 10px;">{{ counterWarmTransfer }}</td>
                </tr>
                <tr style="border-bottom: 1px solid #f0f0f0;">
                    <td class="w-80" style="padding: 10px;">Internet Search</td>
                    <td class="w-20" style="padding: 10px;">{{ countInternetSearch }}</td>
                </tr>
                <tr style="border-bottom: 1px solid #f0f0f0;">
                    <td class="w-80" style="padding: 10px;">Legal System</td>
                    <td class="w-20" style="padding: 10px;">{{ countLegalSystem }}</td>
                </tr>
                <tr style="border-bottom: 1px solid #f0f0f0;">
                    <td class="w-80" style="padding: 10px;">Friends or Other Individual</td>
                    <td class="w-20" style="padding: 10px;">{{ countFriendsorOtherIndividual }}</td>
                </tr>
                <!-- <tr style="border-bottom: 1px solid #f0f0f0;">
                    <td class="w-80" style="padding: 10px;">Problem Gambling Self-Help Group Meetings</td>
                    <td class="w-20" style="padding: 10px;">{{ countProblemGamblingSelfHelpGroupMeetings }}</td>
                </tr>
                    <tr style="border-bottom: 1px solid #f0f0f0;">
                        <td class="w-80 ml-4 d-block" style="padding: 10px;">GA</td>
                        <td class="w-20" style="padding: 10px;">{{ countProblemGamblingSelfHelpGroupMeetingsGA }}</td>
                    </tr>
                    <tr style="border-bottom: 1px solid #f0f0f0;">
                        <td class="w-80 ml-4 d-block" style="padding: 10px;">GamAnon</td>
                        <td class="w-20" style="padding: 10px;">{{ countProblemGamblingSelfHelpGroupMeetingsGamAnon }}</td>
                    </tr>
                    <tr style="border-bottom: 1px solid #f0f0f0;">
                        <td class="w-80 ml-4 d-block" style="padding: 10px;">Smart Recovery</td>
                        <td class="w-20" style="padding: 10px;">{{ countProblemGamblingSelfHelpGroupMeetingsSmartRecovery }}</td>
                    </tr>
                    <tr style="border-bottom: 1px solid #f0f0f0;">
                        <td class="w-80 ml-4 d-block" style="padding: 10px;">Other</td>
                        <td class="w-20" style="padding: 10px;">{{ countProblemGamblingSelfHelpGroupMeetingsOther }}</td>
                    </tr> -->
                <tr style="border-bottom: 1px solid #f0f0f0;">
                    <td class="w-80" style="padding: 10px;">Substance Use Self-Help Group Meetings</td>
                    <td class="w-20" style="padding: 10px;">{{ countSubstanceUseSelfHelpGroupMeetings }}</td>
                </tr>
                <tr style="border-bottom: 1px solid #f0f0f0;">
                    <td class="w-80" style="padding: 10px;">Financial Counseling</td>
                    <td class="w-20" style="padding: 10px;">{{ countFinancialCounseling }}</td>
                </tr>
                <tr style="border-bottom: 1px solid #f0f0f0;">
                    <td class="w-80" style="padding: 10px;">Crisis Services</td>
                    <td class="w-20" style="padding: 10px;">{{ countCrisisServices }}</td>
                </tr>
                <!-- <tr style="border-bottom: 1px solid #f0f0f0;">
                    <td class="w-80" style="padding: 10px;">Problem Gambling Treatment Services</td>
                    <td class="w-20" style="padding: 10px;">{{ countProblemGamblingTreatmentServices }}</td>
                </tr>
                    <tr style="border-bottom: 1px solid #f0f0f0;">
                        <td class="w-80 ml-4 d-block" style="padding: 10px;">Inpatient Rehabilitation</td>
                        <td class="w-20" style="padding: 10px;">{{ countProblemGamblingTreatmentServicesInpatientRehabilitation }}</td>
                    </tr>
                    <tr style="border-bottom: 1px solid #f0f0f0;">
                        <td class="w-80 ml-4 d-block" style="padding: 10px;">Residential</td>
                        <td class="w-20" style="padding: 10px;">{{ countProblemGamblingTreatmentServicesResidential }}</td>
                    </tr>
                    <tr style="border-bottom: 1px solid #f0f0f0;">
                        <td class="w-80 ml-4 d-block" style="padding: 10px;">Outpatient</td>
                        <td class="w-20" style="padding: 10px;">{{ countProblemGamblingTreatmentServicesOutpatient }}</td>
                    </tr> -->
                <!-- <tr style="border-bottom: 1px solid #f0f0f0;">
                    <td class="w-80" style="padding: 10px;">Substance Use Treatment Services</td>
                    <td class="w-20" style="padding: 10px;">{{ countSubstanceUseTreatmentServices }}</td>
                </tr>
                    <tr style="border-bottom: 1px solid #f0f0f0;">
                        <td class="w-80 ml-4 d-block" style="padding: 10px;">Inpatient Rehabilitation</td>
                        <td class="w-20" style="padding: 10px;">{{ countSubstanceUseTreatmentServicesInpatientRehabilitation }}</td>
                    </tr>
                    <tr style="border-bottom: 1px solid #f0f0f0;">
                        <td class="w-80 ml-4 d-block" style="padding: 10px;">Residential</td>
                        <td class="w-20" style="padding: 10px;">{{ countSubstanceUseTreatmentServicesResidential }}</td>
                    </tr>
                    <tr style="border-bottom: 1px solid #f0f0f0;">
                        <td class="w-80 ml-4 d-block" style="padding: 10px;">Outpatient</td>
                        <td class="w-20" style="padding: 10px;">{{ countSubstanceUseTreatmentServicesOutpatient }}</td>
                    </tr>
                <tr style="border-bottom: 1px solid #f0f0f0;">
                    <td class="w-80" style="padding: 10px;">Recovery Support Services</td>
                    <td class="w-20" style="padding: 10px;">{{ countRecoverySupportServices }}</td>
                </tr>
                    <tr style="border-bottom: 1px solid #f0f0f0;">
                        <td class="w-80 ml-4 d-block" style="padding: 10px;">Recovery Community and Outreach Center</td>
                        <td class="w-20" style="padding: 10px;">{{ countRecoverySupportServicesRCOC }}</td>
                    </tr>
                    <tr style="border-bottom: 1px solid #f0f0f0;">
                        <td class="w-80 ml-4 d-block" style="padding: 10px;">Peer Advocate</td>
                        <td class="w-20" style="padding: 10px;">{{ countRecoverySupportServicesPeerAdvocate }}</td>
                    </tr>
                    <tr style="border-bottom: 1px solid #f0f0f0;">
                        <td class="w-80 ml-4 d-block" style="padding: 10px;">Open Access Center</td>
                        <td class="w-20" style="padding: 10px;">{{ countRecoverySupportServicesOpenAccessCenter }}</td>
                    </tr>
                    <tr style="border-bottom: 1px solid #f0f0f0;">
                        <td class="w-80 ml-4 d-block" style="padding: 10px;">Family Navigator</td>
                        <td class="w-20" style="padding: 10px;">{{ countRecoverySupportServicesFamilyNavigator }}</td>
                    </tr>
                    <tr style="border-bottom: 1px solid #f0f0f0;">
                        <td class="w-80 ml-4 d-block" style="padding: 10px;">Regional Addiction Resource Center</td>
                        <td class="w-20" style="padding: 10px;">{{ countRecoverySupportServicesRARC }}</td>
                    </tr>
                    <tr style="border-bottom: 1px solid #f0f0f0;">
                        <td class="w-80 ml-4 d-block" style="padding: 10px;">Youth Clubhouse</td>
                        <td class="w-20" style="padding: 10px;">{{ countRecoverySupportServicesYouthClubhouse }}</td>
                    </tr>
                    <tr style="border-bottom: 1px solid #f0f0f0;">
                        <td class="w-80 ml-4 d-block" style="padding: 10px;">GA</td>
                        <td class="w-20" style="padding: 10px;">{{ countRecoverySupportServicesGA }}</td>
                    </tr>
                    <tr style="border-bottom: 1px solid #f0f0f0;">
                        <td class="w-80 ml-4 d-block" style="padding: 10px;">GamAnon</td>
                        <td class="w-20" style="padding: 10px;">{{ countRecoverySupportServicesGamAnon }}</td>
                    </tr>
                    <tr style="border-bottom: 1px solid #f0f0f0;">
                        <td class="w-80 ml-4 d-block" style="padding: 10px;">Smart Recovery</td>
                        <td class="w-20" style="padding: 10px;">{{ countRecoverySupportServicesSmartRecovery }}</td>
                    </tr> -->
                <tr style="border-bottom: 1px solid #f0f0f0;">
                    <td class="w-80" style="padding: 10px;">Other (please describe)</td>
                    <td class="w-20" style="padding: 10px;">{{ countOtherpleasedescribe }}</td>
                </tr>
                <tr style="border-bottom: 1px solid #f0f0f0;">
                    <td class="w-80" style="padding: 10px;">Other service provider</td>
                    <td class="w-20" style="padding: 10px;">{{ countOtherserviceprovider }}</td>
                </tr>
            </table>
        </b-card>

    </div>
</template>

<script>
import { 
    BForm, BButton, BRow, BCol, BFormGroup, BFormInput, BFormTextarea, BTable, BFormInvalidFeedback, BFormSelect, BCard, BAvatar, BCardBody,
    BSpinner, BFormRadioGroup, BFormRadio,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import flatPickr from 'vue-flatpickr-component'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import { required, email } from '@validations'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import { mapActions, mapGetters, mapState } from 'vuex'
import moment from 'moment'
import { db, auth } from '@/firebase'

export default {
    data() {
        return {
            // validation
            required,
            email,
            totalRows: 0,
            isDataSpecialist: false,
            readyToExport: false,

            // filters
            startDate: null,
            endDate: null,
            region: '',
            borough: '',
            language: '',
            progress: '',
            insurance: '',
            warmTransfer: '',

            // data report
            engagementFormCompleted: 0,
            counterInformationKitAccepted: 0,
            counterInitialAppointmentDate: 0,
            counterTotalEligibleCallers: 0,
            counterAttendedFaceToFaceSession: 0,
            counterAdmittedToTreatment: 0,
            countExistingorpastCFEclient: 0,
            countFamilymemberSelf: 0,
            countGAGamAnon: 0,
            countHOPEline: 0,
            countInternetSearch: 0,
            countLegalSystem: 0,
            countOtherserviceprovider: 0,
            countOtherpleasedescribe: 0,
            counterWarmTransfer: 0,
            countFriendsorOtherIndividual: 0,
            countProblemGamblingSelfHelpGroupMeetings: 0,
            countSubstanceUseSelfHelpGroupMeetings: 0,
            countFinancialCounseling: 0,
            countCrisisServices: 0,
            countProblemGamblingTreatmentServices: 0,
            countSubstanceUseTreatmentServices: 0,
            countRecoverySupportServices: 0,

            countHOPElineYes: 0,
            countHOPElineNo: 0,
            countFamilymemberSelfSelfReferral: 0,
            countFamilymemberSelfSpouce: 0,
            countFamilymemberSelfFamilyMember: 0,
            countProblemGamblingSelfHelpGroupMeetingsGA: 0,
            countProblemGamblingSelfHelpGroupMeetingsGamAnon: 0,
            countProblemGamblingSelfHelpGroupMeetingsSmartRecovery: 0,
            countProblemGamblingSelfHelpGroupMeetingsOther: 0,
            countProblemGamblingTreatmentServicesInpatientRehabilitation: 0,
            countProblemGamblingTreatmentServicesResidential: 0,
            countProblemGamblingTreatmentServicesOutpatient: 0,
            countSubstanceUseTreatmentServicesInpatientRehabilitation: 0,
            countSubstanceUseTreatmentServicesResidential: 0,
            countSubstanceUseTreatmentServicesOutpatient: 0,
            countRecoverySupportServicesRCOC: 0,
            countRecoverySupportServicesPeerAdvocate: 0,
            countRecoverySupportServicesOpenAccessCenter: 0,
            countRecoverySupportServicesFamilyNavigator: 0,
            countRecoverySupportServicesRARC: 0,
            countRecoverySupportServicesYouthClubhouse: 0,
            countRecoverySupportServicesGA: 0,
            countRecoverySupportServicesGamAnon: 0,
            countRecoverySupportServicesSmartRecovery: 0,

            // options
            optionsRegion: [],
            optionsBorough: [
                'Bronx',
                'Brooklyn',
                'Manhattan',
                'Queens',
                'Staten Island'
            ],
            // optionsRegion: [
            //     'Bronx',
            //     'Brooklyn',
            //     'Central',
            //     'Finger Lakes',
            //     'Long Island',
            //     'Manhattan',
            //     'Mid-Hudson',
            //     'Northeast',
            //     'Queens',
            //     'Staten Island',
            //     'Western'
            // ],
            optionsLanguage: [],
            optionsClientProgress: [
                'Any Client Status',
                'Engaged',
                'Closed - Attended First Session',
                'Closed - Did not attend first session',
                'Closed - Received information',
                'Closed - Referred to OASAS Program',
                'External Referral',
                'On Hold'
            ],
            optionsInsurance: [],
            optionsWarmTransfer: ['Yes', 'No'],

            // settings table and edit view
            statusEdit: false,
            itemsActivity: [],
            fieldsTable: [
                { key: 'name', sortable: false },
                { key: 'quantity', sortable: false },
            ],
            arrayTableContent: [
                { 'name': 'Existing or past CFE client', quantity: 0 },
                { 'name': 'Family Member / Self', quantity: 0 },
                { 'name': 'GA/ GamAnon', quantity: 0 },
                { 'name': 'HOPEline', quantity: 0 },
                { 'name': 'Warm Transfer', quantity: 0 },
                { 'name': 'Internet Search', quantity: 0 },
                { 'name': 'Legal System', quantity: 0 },
                { 'name': 'Friends or Other Individual', quantity: 0 },
                { 'name': 'Problem Gambling Self-Help Group Meetings', quantity: 0 },
                { 'name': 'Substance Use Self-Help Group Meetings', quantity: 0 },
                { 'name': 'Financial Counseling', quantity: 0 },
                { 'name': 'Crisis Services', quantity: 0 },
                { 'name': 'Problem Gambling Treatment Services', quantity: 0 },
                { 'name': 'Substance Use Treatment Services', quantity: 0 },
                { 'name': 'Recovery Support Services', quantity: 0 },
                { 'name': 'Other (please describe)', quantity: 0 },
                { 'name': 'Other service provider', quantity: 0 },
            ],

            // json to export csv
            json_data: [],

            // get data from db
            optionsClient: [],
            optionsClinician: [],

            // filter
            clientActivityName: null,
            clientActivityStatus: null,
            selectedRangeDate: 'month',
            optionsRangeDate: [
                { text: 'Month', value: 'month' },
                { text: 'Quarter', value: 'quarter' },
                { text: 'Year', value: 'year' },
                { text: 'Custom', value: 'custom' },
            ],
            clinicianProgram: null,
            optionsProgram: [],

            // reports cards
            totalGroupSessions: 0,
            totalIndividualSessions: 0,
            totalRemoteSessions: 0,
            totalNonEnglishClients: 0,
            clientSatisfaction: 0,
            improved: 0,

            // overlay data
            rangeDinamic: false,
            isBusy: true,
            isBusyCalls: true,

            // new filter
            methodOfContact: '',
            contactStatus: '',
            informationKitAccepted: '',
            regionalCFEReceivingTheCall: '',
            readmission: '',
            connectedToPeerAdvocate: '',
            connectedToVSE: '',
            connectedToPeerEducationGroup: '',
            connectedToFamilyEducationGroup: '',
            connectedToAsianServicesProgram: '',
            referralOptions: '',

            // new fields
            optionsMethodOfContact: [
                'Call',
                'Email',
                'Text',
            ],
            optionsContactStatus: [
                'Family Member',
                'Other',
                'Problem Gambler',
            ],
            optionsInformationKitAccepted: [
                'Yes',
                'No',
            ],
            optionsReadmission: [
                'Yes',
                'No',
            ],
            optionsConnectedToPeerAdvocate: [
                'Yes',
                'No',
            ],
            optionsConnected: [
                'Yes',
                'No',
            ],
            optionsConnectedToPeer: [
                'Yes',
                'No',
            ],
            optionsConnectedToFamily: [
                'Yes',
                'No',
            ],
            optionsConnectedToAsian: [
                'Yes',
                'No',
            ],
            optionsReferralOptions: [
                'OASAS Program',
                'Private Practitioner',
                'Recovery Support Services',
            ],

            // opts
            optMethodOfContact: [
                {name: 'Method of Contact/Call', text: 'Call', count: 0},
                {name: 'Method of Contact/Email', text: 'Email', count: 0},
                {name: 'Method of Contact/Text', text: 'Text', count: 0},
            ],
            optContactStatus: [
                {name: 'Caller Type/Family Member', text: 'Family Member', count: 0},
                {name: 'Caller Type/Other', text: 'Other', count: 0},
                {name: 'Caller Type/Problem Gambler', text: 'Problem Gambler', count: 0},
            ],
            optInformationKitAccepted: [
                {name: 'Information Kit Accepted/Yes', text: 'Yes', count: 0},
                {name: 'Information Kit Accepted/No', text: 'No', count: 0},
            ],
            optReadmission: [
                {name: 'Readmission/Yes', text: 'Yes', count: 0},
                {name: 'Readmission/No', text: 'No', count: 0},
            ],
            optConnectedToPeerAdvocate: [
                {name: 'Connected to Peer Advocate/Yes', text: 'Yes', count: 0},
                {name: 'Connected to Peer Advocate/No', text: 'No', count: 0},
            ],
            optConnected: [
                {name: 'Connected to VSE/Yes', text: 'Yes', count: 0},
                {name: 'Connected to VSE/No', text: 'No', count: 0},
            ],
            optConnectedToPeer: [
                {name: 'Connected to peer education group/Yes', text: 'Yes', count: 0},
                {name: 'Connected to peer education group/No', text: 'No', count: 0},
            ],
            optConnectedToFamily: [
                {name: 'Connected to family education group/Yes', text: 'Yes', count: 0},
                {name: 'Connected to family education group/No', text: 'No', count: 0},
            ],
            optConnectedToAsian: [
                {name: 'Connected to Asian Services Program/Yes', text: 'Yes', count: 0},
                {name: 'Connected to Asian Services Program/No', text: 'No', count: 0},
            ],
            optReferralOptions: [
                {name: 'Referral Options/OASAS Program', text: 'OASAS Program', count: 0},
                {name: 'Referral Options/Private Practitioner', text: 'Private Practitioner', count: 0},
                {name: 'Referral Options/Recovery Support Services', text: 'Recovery Support Services', count: 0},
            ],
            optReferredtoPeerAdvocate: [
                {name: 'Referred to Peer Advocate/Yes', text: 'Yes', count: 0},
                {name: 'Referred to Peer Advocate/No', text: 'No', count: 0},
            ],
            optConnectedtoGamFin: [
                {name: 'Connected to GamFin/Yes', text: 'Yes', count: 0},
                {name: 'Connected to GamFin/No', text: 'No', count: 0},
            ],
            optReferralOASASProgram: [
                {name: 'OASAS Program/Inpatient', text: 'Inpatient', count: 0},
                {name: 'OASAS Program/Residential', text: 'Residential', count: 0},
                {name: 'OASAS Program/Outpatient', text: 'Outpatient', count: 0},
            ],
            optReferralRecoverySupportServices: [
                {name: 'Recovery Support Services/Recovery Community and Outreach Center', text: 'Recovery Community and Outreach Center', count: 0},
                {name: 'Recovery Support Services/Peer Advocate', text: 'Peer Advocate', count: 0},
                {name: 'Recovery Support Services/Open Access Center', text: 'Open Access Center', count: 0},
                {name: 'Recovery Support Services/Family Navigator', text: 'Family Navigator', count: 0},
                {name: 'Recovery Support Services/Regional Addiction Resource Center', text: 'Regional Addiction Resource Center', count: 0},
                {name: 'Recovery Support Services/Youth Clubhouse', text: 'Youth Clubhouse', count: 0},
                {name: 'Recovery Support Services/GA', text: 'GA', count: 0},
                {name: 'Recovery Support Services/GamAnon', text: 'GamAnon', count: 0},
                {name: 'Recovery Support Services/Smart Recovery', text: 'Smart Recovery', count: 0},
            ],
        }
    },
    components: {
        BForm,
        BButton,
        BRow,
        BCol,
        BFormGroup,
        BFormInput,
        BFormTextarea,
        BTable,
        BFormInvalidFeedback,
        BFormSelect,
        BCard,
        BAvatar,
        BCardBody,
        BSpinner,
        BFormRadioGroup,
        BFormRadio,
        DatePicker,
        
        // select
        vSelect,

        // date
        flatPickr,

        // Form Validation
        ValidationProvider,
        ValidationObserver,
    },
    directives: {
        Ripple,
    },
    computed: {
        ...mapGetters(['arrayFiltradoReportsCallData']),
        ...mapState(['searchReportsCallDataStartDateState','searchReportsCallDataEndDateState','searchReportsCallDataRegionState','searchReportsCallDataProgressState','searchReportsCallDataLanguageState','searchReportsCallDataInsuranceState','searchReportsCallDataWarmTransferState','searchReportsCallDataProgramState'])
    },
    watch: {
        selectedRangeDate(val) {
            this.functionDateRange(val)
        },
        clientActivityStatus(val) {
            this.searchClientActivityStatus(val)
        },
        startDate(val) {
            if(val) {
                this.searchReportsCallDataStartDate(val)
                this.functionDateRange(this.selectedRangeDate)
                this.rangeDinamic ? this.rangeDinamic = false : ''
                // this.selectedRangeDate = ''
            } else {
                this.searchReportsCallDataStartDate(null)
            }
        },
        endDate(val) {
            if(val) {
                this.searchReportsCallDataEndDate(val)
            } else {
                this.searchReportsCallDataEndDate(null)
            }
        },
        region(val) {
            // val !== 'NYC' ? this.searchReportsCallDataRegion(val) : ''
            this.searchReportsCallDataRegion(val)
        },
        borough(val) {
            this.searchReportsCallDataRegion(val)
        },
        progress(val) {
            this.searchReportsCallDataProgress(val)
        },
        language(val) {
            this.searchReportsCallDataLanguage(val)
        },
        insurance(val) {
            this.searchReportsCallDataInsurance(val)
        },
        warmTransfer(val) {
            this.searchReportsCallDataWarmTransfer(val)
        },
        clinicianProgram(val) {
            this.searchReportsCallDataProgram(val)
        },
        methodOfContact(val) {
            this.searchReportsCallDatamethodOfContact(val)
        },
        contactStatus(val) {
            this.searchReportsCallDatacontactStatus(val)
        },
        informationKitAccepted(val) {
            this.searchReportsCallDatainformationKitAccepted(val)
        },
        readmission(val) {
            this.searchReportsCallDatareadmission(val)
        },
        connectedToPeerAdvocate(val) {
            this.searchReportsCallDataconnectedToPeerAdvocate(val)
        },
        connectedToVSE(val) {
            this.searchReportsCallDataconnectedToVSE(val)
        },
        connectedToPeerEducationGroup(val) {
            this.searchReportsCallDataconnectedToPeerEducationGroup(val)
        },
        connectedToFamilyEducationGroup(val) {
            this.searchReportsCallDataconnectedToFamilyEducationGroup(val)
        },
        connectedToAsianServicesProgram(val) {
            this.searchReportsCallDataconnectedToAsianServicesProgram(val)
        },
        referralOptions(val) {
            this.searchReportsCallDatareferralOptions(val)
        },
        arrayFiltradoReportsCallData(val) {
            this.isBusy = true
            this.engagementFormCompleted = 0
            this.counterInformationKitAccepted = 0
            this.counterInitialAppointmentDate = 0
            this.counterTotalEligibleCallers = 0
            this.counterAttendedFaceToFaceSession = 0
            this.counterAdmittedToTreatment = 0
            this.countExistingorpastCFEclient = 0
            this.countFamilymemberSelf = 0
            this.countGAGamAnon = 0
            this.countHOPEline = 0
            this.countInternetSearch = 0
            this.countLegalSystem = 0
            this.countOtherserviceprovider = 0
            this.countOtherpleasedescribe = 0
            this.counterWarmTransfer = 0
            this.countFriendsorOtherIndividual = 0
            this.countProblemGamblingSelfHelpGroupMeetings = 0
            this.countSubstanceUseSelfHelpGroupMeetings = 0
            this.countFinancialCounseling = 0
            this.countCrisisServices = 0
            this.countProblemGamblingTreatmentServices = 0
            this.countSubstanceUseTreatmentServices = 0
            this.countRecoverySupportServices = 0
            var arrayExport = []
            this.readyToExport = false
            // var x = 0
            // var y = 0

            this.countHOPElineYes = 0
            this.countHOPElineNo = 0
            this.countFamilymemberSelfSelfReferral = 0
            this.countFamilymemberSelfSpouce = 0
            this.countFamilymemberSelfFamilyMember = 0
            this.countProblemGamblingSelfHelpGroupMeetingsGA = 0
            this.countProblemGamblingSelfHelpGroupMeetingsGamAnon = 0
            this.countProblemGamblingSelfHelpGroupMeetingsSmartRecovery = 0
            this.countProblemGamblingSelfHelpGroupMeetingsOther = 0
            this.countProblemGamblingTreatmentServicesInpatientRehabilitation = 0
            this.countProblemGamblingTreatmentServicesResidential = 0
            this.countProblemGamblingTreatmentServicesOutpatient = 0
            this.countSubstanceUseTreatmentServicesInpatientRehabilitation = 0
            this.countSubstanceUseTreatmentServicesResidential = 0
            this.countSubstanceUseTreatmentServicesOutpatient = 0
            this.countRecoverySupportServicesRCOC = 0
            this.countRecoverySupportServicesPeerAdvocate = 0
            this.countRecoverySupportServicesOpenAccessCenter = 0
            this.countRecoverySupportServicesFamilyNavigator = 0
            this.countRecoverySupportServicesRARC = 0
            this.countRecoverySupportServicesYouthClubhouse = 0
            this.countRecoverySupportServicesGA = 0
            this.countRecoverySupportServicesGamAnon = 0
            this.countRecoverySupportServicesSmartRecovery = 0

            // opts
            this.optMethodOfContact = [
                {name: 'Method of Contact/Call', text: 'Call', count: 0},
                {name: 'Method of Contact/Email', text: 'Email', count: 0},
                {name: 'Method of Contact/Text', text: 'Text', count: 0},
            ]
            this.optContactStatus = [
                {name: 'Caller Type/Family Member', text: 'Family member/Significant Other', count: 0},
                {name: 'Caller Type/Other', text: 'Other', count: 0},
                {name: 'Caller Type/Problem Gambler', text: 'Problem Gambler', count: 0},
            ]
            this.optInformationKitAccepted = [
                {name: 'Information Kit Accepted/Yes', text: 'Yes', count: 0},
                {name: 'Information Kit Accepted/No', text: 'No', count: 0},
            ]
            this.optReadmission = [
                {name: 'Readmission/Yes', text: 'Yes', count: 0},
                {name: 'Readmission/No', text: 'No', count: 0},
            ]
            this.optConnectedToPeerAdvocate = [
                {name: 'Connected to Peer Advocate/Yes', text: 'Yes', count: 0},
                {name: 'Connected to Peer Advocate/No', text: 'No', count: 0},
            ]
            this.optConnected = [
                {name: 'Connected to VSE/Yes', text: 'Yes', count: 0},
                {name: 'Connected to VSE/No', text: 'No', count: 0},
            ]
            this.optConnectedToPeer = [
                {name: 'Connected to peer education group/Yes', text: 'Yes', count: 0},
                {name: 'Connected to peer education group/No', text: 'No', count: 0},
            ]
            this.optConnectedToFamily = [
                {name: 'Connected to family education group/Yes', text: 'Yes', count: 0},
                {name: 'Connected to family education group/No', text: 'No', count: 0},
            ]
            this.optConnectedToAsian = [
                {name: 'Connected to Asian Services Program/Yes', text: 'Yes', count: 0},
                {name: 'Connected to Asian Services Program/No', text: 'No', count: 0},
            ]
            this.optReferralOptions = [
                {name: 'Referral Options/OASAS Program', text: 'OASAS Program', count: 0},
                {name: 'Referral Options/Private Practitioner', text: 'Private Practitioner', count: 0},
                {name: 'Referral Options/Recovery Support Services', text: 'Recovery Support Services', count: 0},
            ]
            this.optReferredtoPeerAdvocate = [
                {name: 'Referred to Peer Advocate/Yes', text: 'Yes', count: 0},
                {name: 'Referred to Peer Advocate/No', text: 'No', count: 0},
            ]
            this.optConnectedtoGamFin = [
                {name: 'Connected to GamFin/Yes', text: 'Yes', count: 0},
                {name: 'Connected to GamFin/No', text: 'No', count: 0},
            ]
            this.optReferralOASASProgram = [
                {name: 'OASAS Program/Inpatient', text: 'Inpatient', count: 0},
                {name: 'OASAS Program/Residential', text: 'Residential', count: 0},
                {name: 'OASAS Program/Outpatient', text: 'Outpatient', count: 0},
            ]
            this.optReferralRecoverySupportServices = [
                {name: 'Recovery Support Services/Recovery Community and Outreach Center', text: 'Recovery Community and Outreach Center', count: 0},
                {name: 'Recovery Support Services/Peer Advocate', text: 'Peer Advocate', count: 0},
                {name: 'Recovery Support Services/Open Access Center', text: 'Open Access Center', count: 0},
                {name: 'Recovery Support Services/Family Navigator', text: 'Family Navigator', count: 0},
                {name: 'Recovery Support Services/Regional Addiction Resource Center', text: 'Regional Addiction Resource Center', count: 0},
                {name: 'Recovery Support Services/Youth Clubhouse', text: 'Youth Clubhouse', count: 0},
                {name: 'Recovery Support Services/GA', text: 'GA', count: 0},
                {name: 'Recovery Support Services/GamAnon', text: 'GamAnon', count: 0},
                {name: 'Recovery Support Services/Smart Recovery', text: 'Smart Recovery', count: 0},
            ]

            val.arregloFiltrado.forEach(dataClientActivity => {
                if(dataClientActivity.includeByAdmission) {
                    if((dataClientActivity.statusLogical === 'Admitted' || dataClientActivity.statusLogical === 'Discharged') && dataClientActivity.admissionDateFormat) {
                        this.counterAdmittedToTreatment += 1
                    }
                }
                
                if(dataClientActivity.includeByContact) {
                    if(dataClientActivity.statusLogical === 'Closed - Received information' || dataClientActivity.statusLogical === 'Closed – Received information') {
                        dataClientActivity.statusLogical = 'Closed – Received information'
                    }
                    // console.log(dataClientActivity.warmTransfer)
                    // Total Individuals
                    // !dataClientActivity.dateIn && !dataClientActivity.dateAd ? 
                    this.engagementFormCompleted += 1 
                    // : ''
                    
                    // Received KTO Kit
                    if(dataClientActivity.informationKitAccepted === 'Yes') {
                        this.counterInformationKitAccepted += 1
                    }

                    // Scheduled For Initial Appointment
                    // if(val.totalInitialAppointment >= 1) {
                    //     this.counterInitialAppointmentDate = val.totalInitialAppointment
                    // } else {
                        if(dataClientActivity.initialAppointmentDate && dataClientActivity.initialAppointmentDate !== ' 00:00') {
                            // if(this.startDate || this.endDate || this.region || this.language || this.warmTransfer) {
                                // dataClientActivity.dateIn ? this.counterInitialAppointmentDate += 1 : ''
                            // } else {
                                // !dataClientActivity.dateAd ?
                                // x += 1
                                this.counterInitialAppointmentDate += 1
                                // dateIn
                                // : ''
                            // }
                        }
                    // }
                    // this.counterInitialAppointmentDate += dataClientActivity.dateIn
                    // else {
                        // dataClientActivity.id === '2633' ? console.log(dataClientActivity) : ''
                        // this.region ? console.log(dataClientActivity.dateAd,dataClientActivity.dateIn) : ''
                        // this.startDate && this.endDate ? console.log(dataClientActivity.id,dataClientActivity.initialAppointmentDate) : ''
                    // }

                    // Total Eligible Callers                'Closed – Received information'
                    if(dataClientActivity.statusLogical !== '' && dataClientActivity.statusLogical !== 'Closed - Received information' && dataClientActivity.statusLogical !== 'Closed – Received information' && dataClientActivity.statusLogical !== 'External Referral') {
                        // !dataClientActivity.dateIn && !dataClientActivity.dateAd ? 
                        this.counterTotalEligibleCallers += 1
                        // : ''
                    }

                    // Attended Face To Face Session
                    // if(dataClientActivity.activityStatus === 'Closed - Attended First Session' || dataClientActivity.activityStatus === 'Admitted' || dataClientActivity.activityStatus === 'Discharged') {
                    if(dataClientActivity.statusLogical === 'Closed - Attended First Session' || dataClientActivity.statusLogical === 'Admitted' || dataClientActivity.statusLogical === 'Discharged') {
                        // if(this.startDate || this.endDate || this.region || this.language || this.warmTransfer) {
                            // dataClientActivity.dateIn ? this.counterAttendedFaceToFaceSession += 1 : ''
                        // } else {
                            // !dataClientActivity.dateIn && !dataClientActivity.dateAd ? 
                            this.counterAttendedFaceToFaceSession += 1 
                            // : ''
                        // }
                    }

                    // Admitted To Treatment
                    // if(val.totalAdmission >= 1) {
                    //     this.counterAdmittedToTreatment = val.totalAdmission
                    // } else {
                        // if(dataClientActivity.statusLogical === 'Admitted' || dataClientActivity.statusLogical === 'Discharged') {
                        //     // y += 1
                        //     this.counterAdmittedToTreatment += 1
                        // }
                    // }
                    // this.counterAdmittedToTreatment += dataClientActivity.dateAd

                    // warmTransfer
                    if(dataClientActivity.warmTransfer) {
                        if(dataClientActivity.warmTransfer === 'Yes') {
                            this.counterWarmTransfer += 1
                        }
                    }

                    if(dataClientActivity.referredBy) {
                        if(dataClientActivity.referredBy === 'Existing or past CFE client') {
                            this.countExistingorpastCFEclient += 1
                        } else if(dataClientActivity.referredBy === 'Family member/Self' || dataClientActivity.referredBy === 'Family Member / Self') {
                            this.countFamilymemberSelf += 1
                        } else if(dataClientActivity.referredBy === 'GA/GamAnon' || dataClientActivity.referredBy === 'GA/ GamAnon') {
                            this.countGAGamAnon += 1
                        } else if(dataClientActivity.referredBy === 'HOPEline') {
                            this.countHOPEline += 1
                        } else if(dataClientActivity.referredBy === 'Internet Search') {
                            this.countInternetSearch += 1
                        } else if(dataClientActivity.referredBy === 'Legal System') {
                            this.countLegalSystem += 1
                        } else if(dataClientActivity.referredBy === 'Other service provider') {
                            this.countOtherserviceprovider += 1
                        } else if(dataClientActivity.referredBy === 'Other (please describe)') {
                            this.countOtherpleasedescribe += 1
                        } else if(dataClientActivity.referredBy === 'Friends or Other Individual') {
                            this.countFriendsorOtherIndividual += 1
                        } else if(dataClientActivity.referredBy === 'Problem Gambling Self-Help Group Meetings') {
                            this.countProblemGamblingSelfHelpGroupMeetings += 1
                        } else if(dataClientActivity.referredBy === 'Substance Use Self-Help Group Meetings') {
                            this.countSubstanceUseSelfHelpGroupMeetings += 1
                        } else if(dataClientActivity.referredBy === 'Financial Counseling') {
                            this.countFinancialCounseling += 1
                        } else if(dataClientActivity.referredBy === 'Crisis Services') {
                            this.countCrisisServices += 1
                        } else if(dataClientActivity.referredBy === 'Problem Gambling Treatment Services') {
                            this.countProblemGamblingTreatmentServices += 1
                        } else if(dataClientActivity.referredBy === 'Substance Use Treatment Services') {
                            this.countSubstanceUseTreatmentServices += 1
                        } else if(dataClientActivity.referredBy === 'Recovery Support Services') {
                            this.countRecoverySupportServices += 1
                        }

                        // wT: dataClientActivity.data().warmTransfer ? dataClientActivity.data().warmTransfer : '',
                        // fMS: dataClientActivity.data().familyMemberSelf ? dataClientActivity.data().familyMemberSelf : '',
                        // pGSM: dataClientActivity.data().problemGamblingSelfHelpGroupMeetings ? dataClientActivity.data().problemGamblingSelfHelpGroupMeetings : '',
                        // pGTS: dataClientActivity.data().problemGamblingTreatmentServices ? dataClientActivity.data().problemGamblingTreatmentServices : '',
                        // sUTS: dataClientActivity.data().substanceUseTreatmentServices ? dataClientActivity.data().substanceUseTreatmentServices : '',
                        // rSS: dataClientActivity.data().recoverySupportServices ? dataClientActivity.data().recoverySupportServices : '',

                        if(dataClientActivity.referredBy === 'HOPEline') {
                            if(dataClientActivity.wT === 'Yes') {
                                this.countHOPElineYes += 1
                            }
                            if(dataClientActivity.wT === 'No') {
                                this.countHOPElineNo += 1
                            }
                        }

                        if(dataClientActivity.referredBy === 'Family member/Self' || dataClientActivity.referredBy === 'Family Member / Self') {
                            if(dataClientActivity.fMS === 'Self-Referral') {
                                this.countFamilymemberSelfSelfReferral += 1
                            }
                            if(dataClientActivity.fMS === 'Spouse') {
                                this.countFamilymemberSelfSpouce += 1
                            }
                            if(dataClientActivity.fMS === 'Family member') {
                                this.countFamilymemberSelfFamilyMember += 1
                            }
                        }

                        if(dataClientActivity.referredBy === 'Problem Gambling Self-Help Group Meetings') {
                            if(dataClientActivity.pGSM === 'GA') {
                                this.countProblemGamblingSelfHelpGroupMeetingsGA += 1
                            }
                            if(dataClientActivity.pGSM === 'GamAnon') {
                                this.countProblemGamblingSelfHelpGroupMeetingsGamAnon += 1
                            }
                            if(dataClientActivity.pGSM === 'Smart Recovery') {
                                this.countProblemGamblingSelfHelpGroupMeetingsSmartRecovery += 1
                            }
                            if(dataClientActivity.pGSM === 'Other') {
                                this.countProblemGamblingSelfHelpGroupMeetingsOther += 1
                            }
                        }

                        if(dataClientActivity.referredBy === 'Problem Gambling Treatment Services') {
                            if(dataClientActivity.pGTS === 'Inpatient Rehabilitation') {
                                this.countProblemGamblingTreatmentServicesInpatientRehabilitation += 1
                            }
                            if(dataClientActivity.pGTS === 'Residential') {
                                this.countProblemGamblingTreatmentServicesResidential += 1
                            }
                            if(dataClientActivity.pGTS === 'Outpatient') {
                                this.countProblemGamblingTreatmentServicesOutpatient += 1
                            }
                        }

                        if(dataClientActivity.referredBy === 'Substance Use Treatment Services') {
                            if(dataClientActivity.sUTS === 'Inpatient Rehabilitation') {
                                this.countSubstanceUseTreatmentServicesInpatientRehabilitation += 1
                            }
                            if(dataClientActivity.sUTS === 'Residential') {
                                this.countSubstanceUseTreatmentServicesResidential += 1
                            }
                            if(dataClientActivity.sUTS === 'Outpatient') {
                                this.countSubstanceUseTreatmentServicesOutpatient += 1
                            }
                        }

                        if(dataClientActivity.referredBy === 'Recovery Support Services') {
                            if(dataClientActivity.rSS === 'Recovery Community and Outreach Center') {
                                this.countRecoverySupportServicesRCOC += 1
                            }
                            if(dataClientActivity.rSS === 'Peer Advocate') {
                                this.countRecoverySupportServicesPeerAdvocate += 1
                            }
                            if(dataClientActivity.rSS === 'Open Access Center') {
                                this.countRecoverySupportServicesOpenAccessCenter += 1
                            }
                            if(dataClientActivity.rSS === 'Family Navigator') {
                                this.countRecoverySupportServicesFamilyNavigator += 1
                            }
                            if(dataClientActivity.rSS === 'Regional Addiction Resource Center') {
                                this.countRecoverySupportServicesRARC += 1
                            }
                            if(dataClientActivity.rSS === 'Youth Clubhouse') {
                                this.countRecoverySupportServicesYouthClubhouse += 1
                            }
                            if(dataClientActivity.rSS === 'GA') {
                                this.countRecoverySupportServicesGA += 1
                            }
                            if(dataClientActivity.rSS === 'GamAnon') {
                                this.countRecoverySupportServicesGamAnon += 1
                            }
                            if(dataClientActivity.rSS === 'Smart Recovery') {
                                this.countRecoverySupportServicesSmartRecovery += 1
                            }
                        }
                    }

                    if(dataClientActivity.methodOfContact) {
                        var filter = this.optMethodOfContact.filter(ele => ele.text === dataClientActivity.methodOfContact || dataClientActivity.methodOfContact.includes(ele.text))
                        if(filter.length) {
                            filter[0].count += 1
                        }
                    }

                    if(dataClientActivity.contactStatus) {
                        if(dataClientActivity.contactStatus === 'Family Member') {
                            var filter = this.optContactStatus.filter(ele => ele.text === 'Family member/Significant Other' || ['Family member/Significant Other'].includes(ele.text))
                            if(filter.length) {
                                filter[0].count += 1
                            }
                        } else {
                            var filter = this.optContactStatus.filter(ele => ele.text === dataClientActivity.contactStatus || dataClientActivity.contactStatus.includes(ele.text))
                            if(filter.length) {
                                filter[0].count += 1
                            }
                        }
                    }

                    if(dataClientActivity.informationKitAccepted) {
                        var filter = this.optInformationKitAccepted.filter(ele => ele.text === dataClientActivity.informationKitAccepted || dataClientActivity.informationKitAccepted.includes(ele.text))
                        if(filter.length) {
                            filter[0].count += 1
                        }
                    }

                    if(dataClientActivity.readmission) {
                        var filter = this.optReadmission.filter(ele => ele.text === dataClientActivity.readmission || dataClientActivity.readmission.includes(ele.text))
                        if(filter.length) {
                            filter[0].count += 1
                        }
                    }

                    if(dataClientActivity.connectedToPeerAdvocate) {
                        var filter = this.optConnectedToPeerAdvocate.filter(ele => ele.text === dataClientActivity.connectedToPeerAdvocate || dataClientActivity.connectedToPeerAdvocate.includes(ele.text))
                        if(filter.length) {
                            filter[0].count += 1
                        }
                    }

                    if(dataClientActivity.connectedToVSE) {
                        var filter = this.optConnected.filter(ele => ele.text === dataClientActivity.connectedToVSE || dataClientActivity.connectedToVSE.includes(ele.text))
                        if(filter.length) {
                            filter[0].count += 1
                        }
                    }

                    if(dataClientActivity.connectedToPeerEducationGroup) {
                        var filter = this.optConnectedToPeer.filter(ele => ele.text === dataClientActivity.connectedToPeerEducationGroup || dataClientActivity.connectedToPeerEducationGroup.includes(ele.text))
                        if(filter.length) {
                            filter[0].count += 1
                        }
                    }

                    if(dataClientActivity.connectedToFamilyEducationGroup) {
                        var filter = this.optConnectedToFamily.filter(ele => ele.text === dataClientActivity.connectedToFamilyEducationGroup || dataClientActivity.connectedToFamilyEducationGroup.includes(ele.text))
                        if(filter.length) {
                            filter[0].count += 1
                        }
                    }

                    if(dataClientActivity.connectedToAsianServicesProgram) {
                        var filter = this.optConnectedToAsian.filter(ele => ele.text === dataClientActivity.connectedToAsianServicesProgram || dataClientActivity.connectedToAsianServicesProgram.includes(ele.text))
                        if(filter.length) {
                            filter[0].count += 1
                        }
                    }

                    if(dataClientActivity.referralOptions) {
                        var filter = this.optReferralOptions.filter(ele => ele.text === dataClientActivity.referralOptions || dataClientActivity.referralOptions.includes(ele.text))
                        if(filter.length) {
                            filter[0].count += 1
                        }
                    }

                    if(dataClientActivity.oasp) {
                        var filter = this.optReferralOASASProgram.filter(ele => ele.text === dataClientActivity.oasp || dataClientActivity.oasp.includes(ele.text))
                        if(filter.length) {
                            filter[0].count += 1
                        }
                    }

                    if(dataClientActivity.rSS) {
                        var filter = this.optReferralRecoverySupportServices.filter(ele => ele.text === dataClientActivity.rSS || dataClientActivity.rSS.includes(ele.text))
                        if(filter.length) {
                            filter[0].count += 1
                        }
                    }

                    if(dataClientActivity.ctgf) {
                        var filter = this.optConnectedtoGamFin.filter(ele => ele.text === dataClientActivity.ctgf || dataClientActivity.ctgf.includes(ele.text))
                        if(filter.length) {
                            filter[0].count += 1
                        }
                    }

                    if(dataClientActivity.rtpa) {
                        var filter = this.optReferredtoPeerAdvocate.filter(ele => ele.text === dataClientActivity.rtpa || dataClientActivity.rtpa.includes(ele.text))
                        if(filter.length) {
                            filter[0].count += 1
                        }
                    }

                    arrayExport.push({
                        id: dataClientActivity.id,
                        // clientID: dataClientActivity.clientID,
                        // language: dataClientActivity.language,
                        // clientName:,
                        status: dataClientActivity.statusLogical,
                        // statusLogical:,
                        contactDate: dataClientActivity.contactDateFormat ? moment(dataClientActivity.contactDateFormat,'DD/MM/YYYY').format('MM/DD/YYYY') : '',
                        // contactDateFormat:,
                        admissionDate: dataClientActivity.admissionDateFormat ? moment(dataClientActivity.admissionDateFormat,'DD/MM/YYYY').format('MM/DD/YYYY') : '',
                        // admissionDateFormat:,
                        dischargeDate: dataClientActivity.dischargeDateFormat ? moment(dataClientActivity.dischargeDateFormat,'DD/MM/YYYY').format('MM/DD/YYYY') : '',
                        region: dataClientActivity.borough ? dataClientActivity.borough : dataClientActivity.region,
                        // insurance: dataClientActivity,

                        // new fields
                        // warmTransfer: dataClientActivity.warmTransfer ? dataClientActivity.warmTransfer : '',
                        methodOfContact: dataClientActivity.methodOfContact ? dataClientActivity.methodOfContact : '',
                        contactStatus: dataClientActivity.contactStatus ? (dataClientActivity.contactStatus === 'Family Member' ? 'Family member/Significant Other' : dataClientActivity.contactStatus) : '',
                        // wasTheCallHelpful: dataClientActivity.wasTheCallHelpful ? dataClientActivity.wasTheCallHelpful : '',
                        readmission: dataClientActivity.readmission ? dataClientActivity.readmission : '',
                        connectedToPeerAdvocate: dataClientActivity.connectedToPeerAdvocate ? dataClientActivity.connectedToPeerAdvocate : '',
                        connectedToVSE: dataClientActivity.connectedToVSE ? dataClientActivity.connectedToVSE : '',
                        connectedToPeerEducationGroup: dataClientActivity.connectedToPeerEducationGroup ? dataClientActivity.connectedToPeerEducationGroup : '',
                        connectedToFamilyEducationGroup: dataClientActivity.connectedToFamilyEducationGroup ? dataClientActivity.connectedToFamilyEducationGroup : '',
                        connectedToAsianServicesProgram: dataClientActivity.connectedToAsianServicesProgram ? dataClientActivity.connectedToAsianServicesProgram : '',
                        informationKitAccepted: dataClientActivity.informationKitAccepted,
                        initialAppointmentDate: dataClientActivity.initialAppointmentDateFormat ? moment(dataClientActivity.initialAppointmentDateFormat,'DD/MM/YYYY').format('MM/DD/YYYY') : '',
                        // initialAppointmentDateFormat: dataClientActivity,
                        // activityStatus: dataClientActivity,
                        howWasClientReferredForServices: dataClientActivity.referredBy,

                        warmTransfer: dataClientActivity.wT && dataClientActivity.referredBy === 'HOPEline' ? dataClientActivity.wT : '',
                        familyMemberSelf: dataClientActivity.fMS && (dataClientActivity.referredBy === 'Family member/Self' || dataClientActivity.referredBy === 'Family Member / Self') ? dataClientActivity.fMS : '',
                        problemGamblingSelfHelpGroupMeetings: dataClientActivity.pGSM && dataClientActivity.referredBy === 'Problem Gambling Self-Help Group Meetings' ? dataClientActivity.pGSM : '',
                        problemGamblingTreatmentServices: dataClientActivity.pGTS && dataClientActivity.referredBy === 'Problem Gambling Treatment Services' ? dataClientActivity.pGTS : '',
                        substanceUseTreatmentServices: dataClientActivity.sUTS && dataClientActivity.referredBy === 'Substance Use Treatment Services' ? dataClientActivity.sUTS : '',
                        recoverySupportServices: dataClientActivity.rSS && dataClientActivity.referredBy === 'Recovery Support Services' ? dataClientActivity.rSS : '',

                        // dateIn: dataClientActivity,
                        // dateAd: dataClientActivity,
                        clientStatusAdmission: dataClientActivity.clientStatusAdmission ? dataClientActivity.clientStatusAdmission : '',
                        primaryICD10: dataClientActivity.primaryICD10 ? dataClientActivity.primaryICD10 : '',
                        locadtrgCompleted: dataClientActivity.locadtrg ? dataClientActivity.locadtrg : '',
                        LOCADTRAssessmentID: dataClientActivity.LOCADTRAssessmentID ? dataClientActivity.LOCADTRAssessmentID : '',

                        // client information
                        clientID: dataClientActivity.clientID ? dataClientActivity.clientID.replace(/#/g, "") : '',
                        insurance: dataClientActivity.clientInsurance ? dataClientActivity.clientInsurance : '',
                        county: dataClientActivity.county ? dataClientActivity.county : '',
                        language: dataClientActivity.language ? dataClientActivity.language : '',
                        // gender: dataClientActivity.gender ? dataClientActivity.gender : '',
                        clinicianProgram: dataClientActivity.clinicianProgram ? dataClientActivity.clinicianProgram : '',
                        clientdateOfBirth: dataClientActivity.cdob ? dataClientActivity.cdob : '',
                        clientFirstTwoLettersLastName: dataClientActivity.ftlln ? dataClientActivity.ftlln : '',
                        clientLast4ofSSN: dataClientActivity.lossn ? dataClientActivity.lossn : '',
                        clientSexAtBirth: dataClientActivity.sxab ? dataClientActivity.sxab : '',
                    })
                }
            })
            this.isBusy = false
            
            this.json_data = arrayExport
            this.readyToExport = true
        }
    },
    methods: {
        ...mapActions(['searchClientActivityName','searchClientActivityStatus','searchClientActivityClinicianName','searchReportsCallDataRegion','searchReportsCallDataProgress','searchReportsCallDataLanguage','searchReportsCallDataInsurance','searchReportsCallDataWarmTransfer','searchClientActivityClinicianStatus','searchClientActivityClientID','searchReportsCallDataStartDate','searchReportsCallDataEndDate','setSnapshotClientActivityReportsCallData','searchReportsCallDataProgram','searchReportsCallDatamethodOfContact','searchReportsCallDatacontactStatus','searchReportsCallDatainformationKitAccepted','searchReportsCallDatareadmission','searchReportsCallDataconnectedToPeerAdvocate','searchReportsCallDataconnectedToVSE','searchReportsCallDataconnectedToPeerEducationGroup','searchReportsCallDataconnectedToFamilyEducationGroup','searchReportsCallDataconnectedToAsianServicesProgram','searchReportsCallDatareferralOptions']),
        activeFilterFunction() {
            this.startDate = null
            this.endDate = null
            this.region = ''
            this.borough = ''
            this.language = ''
            this.progress = ''
            this.insurance = ''
            this.warmTransfer = ''
            this.clinicianProgram = null
            // this.functionFilters()
            this.activeFilters = false
        },
        functionDateRange(val) {
            if(val === 'month') {
                // console.log(this.startDate)
                if(this.startDate) {
                    // '24/03/2022'
                    var formatDate1 = moment(this.startDate,'DD/MM/YYYY').format('MM/DD/YYYY')
                    var formatDate = moment(this.startDate,'DD/MM/YYYY').format('DD/MM/YYYY')
                    var expiredDate = moment(formatDate1).add(1, 'months').subtract(1, 'day')
                    var dateUpdateFormat = moment(expiredDate,'MM/DD/YYYY').format('DD/MM/YYYY')
                    this.startDate = formatDate
                    this.endDate = dateUpdateFormat
                    // console.log(formatDate,expiredDate,dateUpdateFormat)
                } else {
                    var formatDate1 = moment(Date.now()).format('MM/DD/YYYY')
                    var formatDate = moment(Date.now()).format('DD/MM/YYYY')
                    var expiredDate = moment(formatDate1).add(1, 'months').subtract(1, 'day')
                    var dateUpdateFormat = moment(expiredDate,'MM/DD/YYYY').format('DD/MM/YYYY')
                    this.startDate = formatDate
                    this.endDate = dateUpdateFormat
                    // console.log(this.startDate,this.endDate)
                }
            } else if(val === 'quarter') {
                if(this.startDate) {
                    var formatDate1 = moment(this.startDate,'DD/MM/YYYY').format('MM/DD/YYYY')
                    var formatDate = moment(this.startDate,'DD/MM/YYYY').format('DD/MM/YYYY')
                    var expiredDate = moment(formatDate1).add(3, 'months').subtract(1, 'day')
                    var dateUpdateFormat = moment(expiredDate,'MM/DD/YYYY').format('DD/MM/YYYY')
                    this.startDate = formatDate
                    this.endDate = dateUpdateFormat
                    // console.log(formatDate,expiredDate,dateUpdateFormat)
                } else {
                    var formatDate1 = moment(Date.now()).format('MM/DD/YYYY')
                    var formatDate = moment(Date.now()).format('DD/MM/YYYY')
                    var expiredDate = moment(formatDate1).add(3, 'months').subtract(1, 'day')
                    var dateUpdateFormat = moment(expiredDate,'MM/DD/YYYY').format('DD/MM/YYYY')
                    this.startDate = formatDate
                    this.endDate = dateUpdateFormat
                    // console.log(formatDate,expiredDate,dateUpdateFormat)
                }
            } else if(val === 'year') {
                if(this.startDate) {
                    var formatDateNew = moment(this.startDate,'DD/MM/YYYY').format('MM/DD/YYYY')
                    var getYear = moment(formatDateNew).format('YYYY')
                    var formatDate1 = moment('01/01/'+getYear).format('MM/DD/YYYY')
                    var formatDate = '01/01/'+getYear
                    var expiredDate = moment(formatDate1).add(12, 'months').subtract(1, 'day')
                    var dateUpdateFormat = moment(expiredDate,'MM/DD/YYYY').format('DD/MM/YYYY')
                    this.startDate = formatDate
                    this.endDate = dateUpdateFormat
                    // console.log(formatDate,expiredDate,dateUpdateFormat)
                } else {
                    var getYear = moment(Date.now()).format('YYYY')
                    var formatDate1 = moment('01/01/'+getYear).format('MM/DD/YYYY')
                    var formatDate = moment('01/01/'+getYear).format('DD/MM/YYYY')
                    var expiredDate = moment(formatDate1).add(12, 'months').subtract(1, 'day')
                    var dateUpdateFormat = moment(expiredDate,'MM/DD/YYYY').format('DD/MM/YYYY')
                    this.startDate = formatDate
                    this.endDate = dateUpdateFormat
                    // console.log(formatDate,dateUpdateFormat)
                }
            } else if(val === 'x') {
                this.selectedRangeDate = ''
                this.startDate = null
                this.endDate = null
            }
        },
        prevRange() {
            if(this.startDate && this.selectedRangeDate) {
                var formatDate = moment(this.startDate,'DD/MM/YYYY').format('MM/DD/YYYY')
                var subtractDate = moment(formatDate).subtract(1, 'months')
                var dateUpdateFormat = moment(subtractDate,'MM/DD/YYYY').format('DD/MM/YYYY')

                this.rangeDinamic = true
                this.startDate = dateUpdateFormat
                this.functionDateRange(this.selectedRangeDate)
            }
        },
        nextRange() {
            if(this.startDate && this.selectedRangeDate) {
                var formatDate = moment(this.startDate,'DD/MM/YYYY').format('MM/DD/YYYY')
                var subtractDate = moment(formatDate).add(1, 'months')
                var dateUpdateFormat = moment(subtractDate,'MM/DD/YYYY').format('DD/MM/YYYY')

                this.rangeDinamic = true
                this.startDate = dateUpdateFormat
                this.functionDateRange(this.selectedRangeDate)
            }
        },
        functionFilters() {
            if(this.clientActivityStatus) {
                this.searchClientActivityStatus(this.clientActivityStatus)
            } else {
                this.searchClientActivityStatus('')
            }

            if(this.startDate) {
                this.searchReportsCallDataStartDate(this.startDate)
            } else {
                this.searchReportsCallDataStartDate('')
            }

            if(this.endDate) {
                this.searchReportsCallDataEndDate(this.endDate)
            } else {
                this.searchReportsCallDataEndDate('')
            }

            if(this.region) {
                this.searchReportsCallDataRegion(this.region)
            } else {
                this.searchReportsCallDataRegion('')
            }

            if(this.progress) {
                this.searchReportsCallDataProgress(this.progress)
            } else {
                this.searchReportsCallDataProgress('')
            }

            if(this.language) {
                this.searchReportsCallDataLanguage(this.language)
            } else {
                this.searchReportsCallDataLanguage('')
            }

            if(this.insurance) {
                this.searchReportsCallDataInsurance(this.insurance)
            } else {
                this.searchReportsCallDataInsurance('')
            }

            if(this.warmTransfer) {
                this.searchReportsCallDataWarmTransfer(this.warmTransfer)
            } else {
                this.searchReportsCallDataWarmTransfer('')
            }
        }
    },
    created() {
        var user = auth.currentUser
        db.collection('usuarios').doc(user.uid).get()
        .then(doc => {
            this.isDataSpecialist = false
            if(doc.data().role === 'staff') {
                if(doc.data().permissions.includes('data specialist')) {
                    this.isDataSpecialist = true
                }
            } else if(doc.data().role === 'admin') {
                this.isDataSpecialist = true
            }
        })

        this.countHOPElineYes = 0
        this.countHOPElineNo = 0
        this.countFamilymemberSelfSelfReferral = 0
        this.countFamilymemberSelfSpouce = 0
        this.countFamilymemberSelfFamilyMember = 0
        this.countProblemGamblingSelfHelpGroupMeetingsGA = 0
        this.countProblemGamblingSelfHelpGroupMeetingsGamAnon = 0
        this.countProblemGamblingSelfHelpGroupMeetingsSmartRecovery = 0
        this.countProblemGamblingSelfHelpGroupMeetingsOther = 0
        this.countProblemGamblingTreatmentServicesInpatientRehabilitation = 0
        this.countProblemGamblingTreatmentServicesResidential = 0
        this.countProblemGamblingTreatmentServicesOutpatient = 0
        this.countSubstanceUseTreatmentServicesInpatientRehabilitation = 0
        this.countSubstanceUseTreatmentServicesResidential = 0
        this.countSubstanceUseTreatmentServicesOutpatient = 0
        this.countRecoverySupportServicesRCOC = 0
        this.countRecoverySupportServicesPeerAdvocate = 0
        this.countRecoverySupportServicesOpenAccessCenter = 0
        this.countRecoverySupportServicesFamilyNavigator = 0
        this.countRecoverySupportServicesRARC = 0
        this.countRecoverySupportServicesYouthClubhouse = 0
        this.countRecoverySupportServicesGA = 0
        this.countRecoverySupportServicesGamAnon = 0
        this.countRecoverySupportServicesSmartRecovery = 0

        this.$http.get('https://us-central1-nycpg-67e48.cloudfunctions.net/app/api/prod/calldata-reports')
        .then(res => {
            // console.log(res.data)
            // res.data.forEach(ele => {
                this.engagementFormCompleted = res.data.counter.engagementFormCompleted
                this.counterInformationKitAccepted = res.data.counter.counterInformationKitAccepted
                this.counterInitialAppointmentDate = res.data.counter.counterInitialAppointmentDate
                this.counterTotalEligibleCallers = res.data.counter.counterTotalEligibleCallers
                this.counterAttendedFaceToFaceSession = res.data.counter.counterAttendedFaceToFaceSession
                this.counterAdmittedToTreatment = res.data.counter.counterAdmittedToTreatment
                this.countExistingorpastCFEclient = res.data.counter.countExistingorpastCFEclient
                this.countFamilymemberSelf = res.data.counter.countFamilymemberSelf
                this.countGAGamAnon = res.data.counter.countGAGamAnon
                this.countHOPEline = res.data.counter.countHOPEline
                this.countInternetSearch = res.data.counter.countInternetSearch
                this.countLegalSystem = res.data.counter.countLegalSystem
                this.countOtherserviceprovider = res.data.counter.countOtherserviceprovider
                this.countOtherpleasedescribe = res.data.counter.countOtherpleasedescribe

                // wT: dataClientActivity.warmTransfer ? dataClientActivity.warmTransfer : '',
                // fMS: dataClientActivity.familyMemberSelf ? dataClientActivity.familyMemberSelf : '',
                // pGSM: dataClientActivity.problemGamblingSelfHelpGroupMeetings ? dataClientActivity.problemGamblingSelfHelpGroupMeetings : '',
                // pGTS: dataClientActivity.problemGamblingTreatmentServices ? dataClientActivity.problemGamblingTreatmentServices : '',
                // sUTS: dataClientActivity.substanceUseTreatmentServices ? dataClientActivity.substanceUseTreatmentServices : '',
                // rSS: dataClientActivity.recoverySupportServices ? dataClientActivity.recoverySupportServices : '',
                // if(dataClientActivity.referredBy === 'Recovery Support Services') {
                // if(dataClientActivity.referredBy === 'Substance Use Treatment Services') {
                // if(dataClientActivity.referredBy === 'Problem Gambling Treatment Services') {
                // if(dataClientActivity.referredBy === 'Problem Gambling Self-Help Group Meetings') {
                // if(dataClientActivity.referredBy === 'Family member/Self' || dataClientActivity.referredBy === 'Family Member / Self') {
                // if(dataClientActivity.referredBy === 'HOPEline') {
                this.countHOPElineYes = res.data.activity.filter(eleAct => eleAct.wT === 'Yes' && eleAct.referredBy === 'HOPEline').length
                this.countHOPElineNo = res.data.activity.filter(eleAct => eleAct.wT === 'No'  && eleAct.referredBy === 'HOPEline').length
                this.countFamilymemberSelfSelfReferral = res.data.activity.filter(eleAct => eleAct.fMS === 'Self-Referral' && eleAct.referredBy === 'Family member/Self' || eleAct.referredBy === 'Family Member / Self').length
                this.countFamilymemberSelfSpouce = res.data.activity.filter(eleAct => eleAct.fMS === 'Spouse' && eleAct.referredBy === 'Family member/Self' || eleAct.referredBy === 'Family Member / Self').length
                this.countFamilymemberSelfFamilyMember = res.data.activity.filter(eleAct => eleAct.fMS === 'Family member' && eleAct.referredBy === 'Family member/Self' || eleAct.referredBy === 'Family Member / Self').length
                this.countProblemGamblingSelfHelpGroupMeetingsGA = res.data.activity.filter(eleAct => eleAct.pGSM === 'GA' && eleAct.referredBy === 'Problem Gambling Self-Help Group Meetings').length
                this.countProblemGamblingSelfHelpGroupMeetingsGamAnon = res.data.activity.filter(eleAct => eleAct.pGSM === 'GamAnon' && eleAct.referredBy === 'Problem Gambling Self-Help Group Meetings').length
                this.countProblemGamblingSelfHelpGroupMeetingsSmartRecovery = res.data.activity.filter(eleAct => eleAct.pGSM === 'Smart Recovery' && eleAct.referredBy === 'Problem Gambling Self-Help Group Meetings').length
                this.countProblemGamblingSelfHelpGroupMeetingsOther = res.data.activity.filter(eleAct => eleAct.pGSM === 'Other' && eleAct.referredBy === 'Problem Gambling Self-Help Group Meetings').length
                this.countProblemGamblingTreatmentServicesInpatientRehabilitation = res.data.activity.filter(eleAct => eleAct.pGTS === 'Inpatient Rehabilitation' && eleAct.referredBy === 'Problem Gambling Treatment Services').length
                this.countProblemGamblingTreatmentServicesResidential = res.data.activity.filter(eleAct => eleAct.pGTS === 'Residential' && eleAct.referredBy === 'Problem Gambling Treatment Services').length
                this.countProblemGamblingTreatmentServicesOutpatient = res.data.activity.filter(eleAct => eleAct.pGTS === 'Outpatient' && eleAct.referredBy === 'Problem Gambling Treatment Services').length
                this.countSubstanceUseTreatmentServicesInpatientRehabilitation = res.data.activity.filter(eleAct => eleAct.sUTS === 'Inpatient Rehabilitation' && eleAct.referredBy === 'Substance Use Treatment Services').length
                this.countSubstanceUseTreatmentServicesResidential = res.data.activity.filter(eleAct => eleAct.sUTS === 'Residential' && eleAct.referredBy === 'Substance Use Treatment Services').length
                this.countSubstanceUseTreatmentServicesOutpatient = res.data.activity.filter(eleAct => eleAct.sUTS === 'Outpatient' && eleAct.referredBy === 'Substance Use Treatment Services').length
                this.countRecoverySupportServicesRCOC = res.data.activity.filter(eleAct => eleAct.rSS === 'Recovery Community and Outreach Center' && eleAct.referredBy === 'Recovery Support Services').length
                this.countRecoverySupportServicesPeerAdvocate = res.data.activity.filter(eleAct => eleAct.rSS === 'Peer Advocate' && eleAct.referredBy === 'Recovery Support Services').length
                this.countRecoverySupportServicesOpenAccessCenter = res.data.activity.filter(eleAct => eleAct.rSS === 'Open Access Center' && eleAct.referredBy === 'Recovery Support Services').length
                this.countRecoverySupportServicesFamilyNavigator = res.data.activity.filter(eleAct => eleAct.rSS === 'Family Navigator' && eleAct.referredBy === 'Recovery Support Services').length
                this.countRecoverySupportServicesRARC = res.data.activity.filter(eleAct => eleAct.rSS === 'Regional Addiction Resource Center' && eleAct.referredBy === 'Recovery Support Services').length
                this.countRecoverySupportServicesYouthClubhouse = res.data.activity.filter(eleAct => eleAct.rSS === 'Youth Clubhouse' && eleAct.referredBy === 'Recovery Support Services').length
                this.countRecoverySupportServicesGA = res.data.activity.filter(eleAct => eleAct.rSS === 'GA' && eleAct.referredBy === 'Recovery Support Services').length
                this.countRecoverySupportServicesGamAnon = res.data.activity.filter(eleAct => eleAct.rSS === 'GamAnon' && eleAct.referredBy === 'Recovery Support Services').length
                this.countRecoverySupportServicesSmartRecovery = res.data.activity.filter(eleAct => eleAct.rSS === 'Smart Recovery' && eleAct.referredBy === 'Recovery Support Services').length

                this.setSnapshotClientActivityReportsCallData(res.data.activity)
                this.isBusy = false
                this.isBusyCalls = false
            // })
        })

        // filters
        this.startDate = this.searchReportsCallDataStartDateState ? this.searchReportsCallDataStartDateState : null
        this.endDate = this.searchReportsCallDataEndDateState ? this.searchReportsCallDataEndDateState : null
        this.region = this.searchReportsCallDataRegionState ? this.searchReportsCallDataRegionState : ''
        this.progress = this.searchReportsCallDataProgressState ? this.searchReportsCallDataProgressState : ''
        this.language = this.searchReportsCallDataLanguageState ? this.searchReportsCallDataLanguageState : ''
        this.insurance = this.searchReportsCallDataInsuranceState ? this.searchReportsCallDataInsuranceState : ''
        this.warmTransfer = this.searchReportsCallDataWarmTransferState ? this.searchReportsCallDataWarmTransferState : ''
        this.clinicianProgram = this.searchReportsCallDataProgramState ? (this.searchReportsCallDataProgramState === 'oasas' ? 'OASAS' : this.searchReportsCallDataProgramState === 'pgrc - private practitioner' ? 'PGRC - Private Practitioner' : this.searchReportsCallDataProgramState === 'pgrc - group practice' ? 'PGRC - Group Practice' : this.searchReportsCallDataProgramState === 'pgrc - oasas program' ? 'PGRC - OASAS Program' : null) : null

        db.collection('clients').get()
        .then(docsClients => {
            this.totalNonEnglishClients = 0
            this.clientSatisfaction = 0
            docsClients.forEach(itemClient => {
                if(itemClient.data().status === 'active') {
                    var languageLowerCase = itemClient.data().primaryLanguage.toLowerCase()
                    if(!languageLowerCase.includes("english")) {
                        this.totalNonEnglishClients += 1
                    }
                }
            })
        })

        db.collection('taxonomies').doc('client').get()
        .then(docTaxonomia => {
            // profile fields
            // this.optionsRegion = docTaxonomia.data().region
            this.optionsLanguage = docTaxonomia.data().primaryLanguage
            this.optionsInsurance = docTaxonomia.data().insuranceType
        })

        db.collection('taxonomies').doc('clinician').get()
        .then(docTaxonomia => {
            // profile fields
            this.optionsRegion = docTaxonomia.data().region

            var arrayProgram = [{value: null, text: 'Any Program'}]
            docTaxonomia.data().program.forEach(item => {
                arrayProgram.push({value: item, text: item})
            })
            this.optionsProgram = arrayProgram
        })
    }
}
</script>

<style>
.mx-input {
    height: 37px !important;
}
.hidden_header {
    display: none;
}
.form-control {
    background: #fff !important;
    background-color: #fff !important;
}
.range-date {
    padding: 8px;
    margin-top: 27px;
}
.vs__dropdown-option {
  white-space: normal !important;
}
.vs__dropdown-toggle {
  max-height: 38px;
}
.vs__selected-options {
  overflow: auto;
}
.vs__selected-options {
    overflow-x: hidden;
    overflow-y: hidden;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';

.repeater-form {
  overflow: hidden;
  transition: .35s height;
}
</style>